import React, {
  useRef,
  useState,
  useEffect,
  FunctionComponent,
  SVGProps,
} from "react";
import { Tab, Nav, Row, Col } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";
import EmployeeImage from "../employees/employeeImage";
import Footer from "../../Footer";
import Table from "../../core/common/dataTable/index";
import { DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";
import useDynamicPageSize from "../../useDynamicPageSize";
import CommonSelect, { Option } from "../../core/common/commonSelect";
import api from "../../api";
import { REACT_APP_API_BASE_URL } from "../../environment";
import { REACT_APP_ANALYSIS_API_BASE_URL } from "../../environment";

import {
  FaEdit,
  FaTrashAlt,
  FaEye,
  FaDownload,
  FaCloudUploadAlt,
  FaInfoCircle,
} from "react-icons/fa";
import { IconType } from "react-icons";
import nodeApi from "../../nodeApi";

// Helper that casts IconType into a valid FunctionComponent for createElement
const renderIcon = (Icon: IconType) =>
  React.createElement(Icon as FunctionComponent<SVGProps<SVGSVGElement>>, {});

interface DocumentItem {
  id: number;
  emp_doc_id: number;
  document_type: string;
  document_path: string | null;
  document_number?: string;
  document_submitted?: boolean;
  document_uploaded?: boolean;
}

interface CTCItem {
  id: number;
  from_date: string;
  to_date: string;
  ctc: any;
}

interface LeaveItem {
  id: number;
  user_id: number;
  leave_id: number | null;
  date: string;
  no_of_leaves: number;
  type: number;
  notes: string;
  total_leaves: number;
  flag: number;
  created_at: string;
  updated_at: string;
}
interface InventoryItem {
  id: number;
  device_code?: string;
  inventory_type?: {
    name: string;
    image_icon?: string;
  };
  inventory_brand?: {
    name: string;
  };
}
interface InventoryResponse {
  data: InventoryItem[];
  inventorytype: any[];
}

interface InventoryOption {
  value: string;
  label: string;
}
type EmployeeType = {
  id: number;
  name: string;
  eId: any;
  phoneNumber: number;
  joinDate: string;
  imageUrl?: string;
  designation: { title: string };
};
type EmployeeData = {
  id: string;
  employee_id: string;
  name: string;
  email: string;
  date_of_birth: string;
  phone_number: string;
  gender: number | string;
  pan_number: string;
  address: string;
  employment_status: number | string;
  date_of_joining: string;
  reporting_head: string | number;
  user_role: string | number;
  designation: string;
  designation_id: number;
  by_pass_attendance: boolean;
  permanent_wfh: boolean;
  account_number: string;
  account_name: string;
  branch_name: string;
  ifsc: string;
  is_active?: number | string | boolean;
  flag?: number | string | boolean;
  image_url?: string;
  PAN?: string;
  status?: number | string;
  date_of_leaving?: string;
  date_of_internship?: string;
  bank_details?: any;
  role_name?: string | number;
  is_permenant_wfh?: number | boolean;
  by_pass_attendance_check?: number | boolean;
};
interface OnboardingStep {
  key: string;
  label: string;
  completed: boolean;
  mandatory: boolean;
  locked?: boolean;
  count?: number;
  required?: number;
}

interface OnboardingResponse {
  employeeId: number;
  steps: OnboardingStep[];
  summary: {
    mandatorySteps: number;
    completedMandatory: number;
    isComplete: boolean;
    onboardingMarkedComplete?: boolean;
    isOnboardingComplete?: boolean;
  };
}

interface InductionItem {
  id: number;
  title: string;
  description: string;
  completed: boolean;
}

interface ExitStep {
  key: string;
  label: string;
  completed: boolean;
  mandatory: boolean;
  locked?: boolean;
  count?: number;
  required?: number;
}

interface ExitSummary {
  mandatorySteps: number;
  completedMandatory: number;
  isComplete: boolean;
  isExitComplete?: boolean;
  dateOfLeaving?: string;
  status?: number | string;
  isReleased?: boolean;
  isActive?: boolean;
}

interface ExitResponse {
  employeeId: number;
  steps: ExitStep[];
  summary: ExitSummary;
}
const Profile: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const [employeeData, setEmployeeData] = useState<EmployeeData | null>(null);
  const [showDeleteModal1, setShowDeleteModal1] = useState(false);
  const [structureToDeleteId, setStructureToDeleteId] = useState<number | null>(
    null
  );
  const [onboardingData, setOnboardingData] =
    useState<OnboardingResponse | null>(null);
  const [onboardingMarkedComplete, setOnboardingMarkedComplete] =
    useState<boolean>(false);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const location = useLocation();
  const [isSaving, setisSaving] = useState(false);
  const state = location.state as {
    selectedUserId: number;
    employeeName: string;
    employeeImage: string;
    designation: string;
    previousUrl: string;
  };

  const pageSize = useDynamicPageSize();
  const [designationsList, setDesignationsList] = useState<EmployeeType[]>([]);
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});
  const [selectedDesignation, setSelectedDesignation] = useState<any>(null);
  const [modalDesignationOptions, setModalDesignationOptions] = useState<
    Option[]
  >([]);
  const [modalStatusOptions, setModalStatusOptions] = useState<Option[]>([]);

  const isExitStatus = (status: any) => {
    const label = modalStatusOptions.find((opt) => opt.value === status)?.label;
    return ["Notice Period", "Released", "Terminated"].includes(label || "");
  };
  const [selectedStatus, setSelectedStatus] = useState<any>(null);
  const [reportingHeadOptions, setReportingHeadOptions] = useState<Option[]>(
    []
  );
  const [userRoleOptions, setUserRoleOptions] = useState<Option[]>([]);
  const [leavePage, setLeavePage] = useState<number>(1);
  const [isExitEmployee, setIsExitEmployee] = useState<boolean | null>(null);
  const isInitialLoadRef = useRef(true);
  const lastLeavingDateRef = useRef<Date | string | null>(null);
  const [documentSubmitted, setDocumentSubmitted] = useState<boolean | null>(null);
  const hasShownDocReminderRef = useRef<boolean>(false);
  const submitAfterOnboardingRef = useRef<boolean>(false);


  // const debouncedSearchTerm = useDebounce(searchTerm, 300);
  // Shared User ID State
  const [selectedUserId, setSelectedUserId] = useState<number>(0);
  const [leavePerPage, setLeavePerPage] = useState<number>(pageSize);

  // Documents State
  const [documents, setDocuments] = useState<DocumentItem[]>([]);
  const [docTotal, setDocTotal] = useState<number>(0);
  const [docPage, setDocPage] = useState<number>(1);
  const [docPerPage, setDocPerPage] = useState<number>(8); // default 8
  const [totalItems, setTotalItems] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [docError, setDocError] = useState<string | null>(null);

  // Documents Modal State
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [documentForm, setDocumentForm] = useState<any>({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [documentToDeleteId, setDocumentToDeleteId] = useState<number | null>(
    null
  );

  // Leave Balance State
  const [leaveItems, setLeaveItems] = useState<LeaveItem[]>([]);
  const [leaveTotalItems, setLeaveTotalItems] = useState<number>(0);
  const [leaveCurrentPage, setLeaveCurrentPage] = useState<number>(1);
  const [leaveError, setLeaveError] = useState<string | null>(null);

  // Tab key
  const [key, setKey] = useState<"documents" | "inventory" | "ctc" | "leave" | "analysis">(
    "documents"
  );

  const [inductionData, setInductionData] = useState<InductionItem[]>([]);
  const [inductionLoading, setInductionLoading] = useState<boolean>(false);

  const [genderOptions, setGenderOptions] = useState<Option[]>([]);
  const [ctcData, setCTCData] = useState<CTCItem[]>([]);
  // const [loadingCTC, setLoadingCTC] = useState(false);
  //   const [errorCTC, setErrorCTC] = useState<string | null>(null);

  const [ctc, setCtc] = useState<string>("");
  const [gross, setGross] = useState<string>("");
  const [AnnextureBTotal, setAnnextureBtotal] = useState<string>("");
  const [totalDeduction, setTotalDeduction] = useState<string>("");
  const [monthCTC, setMonthCTC] = useState<string>("");
  const [islatest, setIsLatest] = useState(false);
  const [fromDate, setFromDate] = useState<Date | Dayjs | null>(null);
  const [payheadValues, setPayheadValues] = useState<Record<string, number>>(
    {}
  );
  const [netSalary, setNetSalary] = useState<string>("");
  const [basicSalary, setBasicSalary] = useState<string>("");
  const [houseRent, sethouseRent] = useState<string>("");
  const [travelAllowance, setTravelAllowance] = useState<string>("");
  const [medicalAllowance, setMedicalAllowance] = useState<string>("");
  const [professionalTax, setProfessionalTax] = useState<string>("");
  const [securityDeposit, setSecurityDeposit] = useState<string>("");
  const [specialAllowance, setSpecialAllowance] = useState<string>("");
  const [cityCompensatoryAllowance, setCityCompensatoryAllowance] =
    useState<string>("");
  const [leaveTravel, setleaveTravel] = useState<string>("");
  const [mobileInternet, setMobileInternet] = useState<string>("");
  const [tds, setTds] = useState<string>("");
  const [basic, setBasic] = useState<string>("");
  const [basicSalaryAnnual, setBasicSalaryAnnual] = useState<string>("");
  const [houseRentAnnual, sethouseRentAnnual] = useState<string>("");
  const [travelAllowanceAnnual, setTravelAllowanceAnnual] =
    useState<string>("");
  const [medicalAllowanceAnnual, setMedicalAllowanceAnnual] =
    useState<string>("");
  const [professionalTaxAnnual, setProfessionalTaxAnnual] =
    useState<string>("");
  const [securityDepositAnnual, setSecurityDepositAnnual] =
    useState<string>("");
  const [specialAllowanceAnnual, setSpecialAllowanceAnnual] =
    useState<string>("");
  const [cityCompensatoryAllowanceAnnual, setCityCompensatoryAllowanceAnnual] =
    useState<string>("");
  const [leaveTravelAnnual, setleaveTravelAnnual] = useState<string>("");
  const [mobileInternetAnnual, setMobileInternetAnnual] = useState<string>("");
  const [tdsAnnual, setTdsAnnual] = useState<string>("");
  const [basicAnnual, setBasicAnnual] = useState<string>("");

  const [netSalaryAnnual, setNetSalaryAnnual] = useState<string>("");
  const [originalSA, setOriginalSA] = useState<string>("");

  const [ctcErrors, setCtcErrors] = useState<{
    ctc?: string;
    fromDate?: string;
  }>({});
  const [editingCTC, setEditingCTC] = useState(false);
  const [ctcId, setCTCId] = useState<number | null>(null);
  const [showCTCModal, setShowCTCModal] = useState(false);
  const [payheadData, setPayheadData] = useState<
    { code: string; name: string, category: string, description:string }[]
  >([]);
  const modalRef = useRef<HTMLDivElement>(null); //

  const [inventoryData, setInventoryData] = useState<InventoryItem[]>([]);
  const [inventoryType, setInventoryType] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState<InventoryOption[]>([]);
  const [analysisFromDate, setAnalysisFromDate] = useState<Dayjs | null>(null);
  const [analysisToDate, setAnalysisToDate] = useState<Dayjs | null>(null);

  const [analysisId, setAnalysisId] = useState<string | null>(null);
  const [analysisStatus, setAnalysisStatus] = useState<string | null>(null);
  const [analysisProgress, setAnalysisProgress] = useState<number>(0);
  const [analysisResult, setAnalysisResult] = useState<any>(null);

  const analysisPollRef = useRef<NodeJS.Timeout | null>(null);
  const [analysisLoading, setAnalysisLoading] = useState(false);
  const currentYearStart = dayjs().startOf("year");
  const currentYearEnd = dayjs().endOf("year");


  const parseApiDate = (dateStr: string | null | undefined): string => {
    if (!dateStr) return "";
    const parsed = dayjs(dateStr, "DD-MM-YYYY", true);
    return parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
  };

  const formatDisplayDate = (dateStr: string | null | undefined): string => {
    if (!dateStr) return "";
    const parsed = dayjs(dateStr, "DD-MM-YYYY", true);
    return parsed.isValid() ? parsed.format("DD-MMM-YYYY").toUpperCase() : "";
  };
  const stopAnalysisWithError = (msg?: string) => {
    if (analysisPollRef.current) {
      clearInterval(analysisPollRef.current);
      analysisPollRef.current = null;
    }

    setAnalysisLoading(false);
    setAnalysisStatus("error");
    setAnalysisProgress(0);

    toast.error(msg || "Analysis failed");
  };

  const formatDateToYYYYMMDD = (date: string): string => {
    if (!date) return "";
    const parsed = dayjs(
      date,
      ["DD-MM-YYYY", "DD-MMM-YYYY", "YYYY-MM-DD"],
      true
    );
    return parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
  };

  const [formData, setFormData] = useState({
    id: "",
    employee_id: "",
    is_active: true as boolean | number | string,
    name: "",
    email: "",
    dob: null as Date | string | null,
    joiningDate: null as Date | string | null,
    contact: "",
    gender: "",
    pan: "",
    photo: "",
    address: "",
    password: "",
    employmentStatus: "",
    leavingDate: null as Date | string | null,
    internshipDate: null as Date | string | null,
    designation: "",
    reportingHead: "",
    userRole: "",
    bypassAttendance: false,
    permanentWfh: false,
    flag: false,
    accountNumber: "",
    accountName: "",
    branchName: "",
    ifscCode: "",
    image_url: "",
  });
  // const [selectedUserId, setSelectedUserId] = useState<number | null>(null); // provide this from profile
  const [roleName, setRoleName] = useState<string>("");
  const [exitData, setExitData] = useState<ExitResponse | null>(null);
  const isDisabled = roleName == '2';
  const prevStatusRef = useRef<string>(formData.employmentStatus);

useEffect(() => {
  if (selectedUserId && isExitEmployee === false) {
    fetchOnboardingProgress();
  }
}, [selectedUserId, isExitEmployee]);

useEffect(() => {
  if (!selectedUserId || !isExitEmployee) return;
  refreshLifecycleProgress();
}, [selectedUserId, isExitEmployee]);

  useEffect(() => {
      const userString = localStorage.getItem("user");
      const user = userString ? JSON.parse(userString) : null;
      setRoleName(user?.role_name);
      console.log("role name",roleName);
     const fetchEmployeeDetails = async () => {
      try {
        const res = await api<any>(`/edit-employee/${selectedUserId}`, {
          method: "GET",
        });
        console.log("Full API response:", res.data);

        const employee = res.data;
        const employees = res;

        console.log("designations from API", res.data.designation);

        // Set dropdown options
        const genderOptions: Option[] = Object.entries(
          employees.gender || {}
        ).map(([value, label]) => ({ value, label: String(label) }));

        const statusOptions: Option[] = Object.entries(
          employees.status || {}
        ).map(([value, label]) => ({ value, label: String(label) }));

        const userRoleOptions: Option[] = Object.entries(
          employees.userrole || {}
        ).map(([value, label]) => ({ value, label: String(label) }));

        const designationOptions: Option[] = employees.designations.map(
          (item: any) => ({
            value: item.id.toString(),
            label: item.title,
          })
        );

        const reportingHeadOptions: Option[] = (
          employees.reporting_head || []
        ).map((item: any) => ({
          value: item.id.toString(),
          label: item.name,
        }));
        console.log("modalDesignationOptions", modalDesignationOptions);
        console.log(
          "employeeData.designation_id",
          employeeData === null || employeeData === void 0
            ? void 0
            : employeeData.designation_id
        );
        console.log("reportingHeadOptions", reportingHeadOptions);
        console.log("userRoleOptions", userRoleOptions);
        console.log("genderOptions", genderOptions);
        // Set dropdowns
        setGenderOptions(genderOptions);
        setModalStatusOptions(statusOptions);
        setUserRoleOptions(userRoleOptions);
        setModalDesignationOptions(designationOptions);
        setReportingHeadOptions(reportingHeadOptions);
// After building statusOptions:
const currentStatusValue = employee.status?.toString() || "";
const currentStatusLabel =
  statusOptions.find((o) => o.value === currentStatusValue)?.label || "";
const isExitAtLoad = ["Notice Period", "Released", "Terminated"].includes(
  currentStatusLabel
);
setIsExitEmployee(isExitAtLoad);
        // Set employee data
        setEmployeeData({
          id: employee.id,
          employee_id: employee.employee_id,
          name: employee.name,
          email: employee.email,
          // flag: employee.flag,
          date_of_birth: employee.date_of_birth,
          phone_number: employee.phone_number,
          gender: employee.gender?.toString(),
          pan_number: employee.PAN,
          address: employee.address,
          employment_status: employee.status?.toString(),
          date_of_joining: employee.date_of_joining,
          designation_id: employee.designation_id,
          designation: employee.designation?.title || "",
          reporting_head: employee.reporting_head_id,
          user_role: employee.role_name?.toString(),
          permanent_wfh: !!employee.is_permenant_wfh,
          by_pass_attendance: !!employee.by_pass_attendance_check,
          account_number: employee.bank_details?.account_number || "",
          account_name: employee.bank_details?.account_name || "",
          branch_name: employee.bank_details?.branch_name || "",
          ifsc: employee.bank_details?.ifsc || "",
        });
        setFormData({
          id: employee.id || "",
          employee_id: employee.employee_id || "",
          image_url: employee.image_url || "",
          name: employee.name || "",
          email: employee.email || "",
          flag: !!employee.flag,
          is_active: employee.is_active,
          dob: parseApiDate(employee.date_of_birth),
          contact: employee.phone_number || "",
          gender: employee.gender?.toString() || "",
          pan: employee.PAN || "",
          photo: "", // could also preload image URL if needed
          address: employee.address || "",
          employmentStatus: employee.status?.toString() || "",
          joiningDate: formatDateToYYYYMMDD(employee.date_of_joining),
           leavingDate: isExitAtLoad
    ? formatDateToYYYYMMDD(employee.date_of_leaving)
    : null,
          internshipDate: formatDateToYYYYMMDD(employee.date_of_internship),
          designation: employee.designation_id?.toString() || "",
          reportingHead: employee.reporting_head_id?.toString() || "",
          userRole: employee.role_name?.toString() || "",
          password: "", // left blank for editing
          bypassAttendance: !!employee.by_pass_attendance_check,
          permanentWfh: !!employee.is_permenant_wfh,
          accountNumber: employee.bank_details?.account_number || "",
          accountName: employee.bank_details?.account_name || "",
          branchName: employee.bank_details?.branch_name || "",
          ifscCode: employee.bank_details?.ifsc || "",
        });
        prevStatusRef.current = employee.status?.toString() || "";
        console.log("modalDesignationOptions", modalDesignationOptions);
        console.log(
          "employeeData.designation_id",
          employeeData?.designation_id
        );
        console.log("reportingHeadOptions", reportingHeadOptions);
        console.log("userRoleOptions", userRoleOptions);
        console.log("genderOptions", genderOptions);
      } catch (err: any) {
        console.error(err);
        setError("Failed to load employee details.");
      } finally {
        setLoading(false);
      }
    };

    if (selectedUserId) fetchEmployeeDetails();
  }, [selectedUserId]);

  // Initialize selectedUserId
  useEffect(() => {
    if (id) {
      setSelectedUserId(Number(id));
    } else if (state?.selectedUserId) {
      setSelectedUserId(state.selectedUserId);
    }
  }, [id, state]);
  const generatePassword = async () => {
    try {
      const res = await api<{ password: string }>(
        "/employees/generatepassword",
        {
          method: "GET",
        }
      );

      if (res.password) {
        setFormData((prev) => ({
          ...prev,
          password: res.password,
        }));
        toast.success("Password generated successfully!");
      } else {
        toast.error("Failed to generate password.");
      }
    } catch (error) {
      console.error("Password generation failed:", error);
      toast.error("Something went wrong while generating password.");
    }
  };
  // after you’ve declared fetchInventoryData and the selectedUserId state:
  useEffect(() => {
    // only fetch once we have a real user ID
    if (!selectedUserId) return;
    fetchInventoryData();
  }, [selectedUserId]);

  const fetchInventoryData = async () => {
    if (!selectedUserId) return;
    setIsLoading(true);

    try {
      const res = (await api(
        `/inventory-data/${selectedUserId}`
      )) as InventoryResponse;

      setInventoryData(res.data || []);
      setInventoryType(res.inventorytype || []);
    } catch (error) {
      console.warn("Error loading inventory:", error);
      setInventoryData([]);
      setInventoryType([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddInventoryClick = () => {
    setIsModalOpen(true);
    setSelectedOptions([]);
  };

  const handleInventoryTypeChange = (selected: any) => {
    setSelectedOptions(selected || []);
  };

  const handleSubmitInventory = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedUserId) return;

    const payload = {
      employee_id: selectedUserId,
      discription: selectedOptions.map((opt) => opt.value),
    };

    try {
      await api("/alloted-inventory", {
        method: "POST",
        body: payload,
      });

      setIsModalOpen(false);
      fetchInventoryData();
      await refreshLifecycleProgress();
    } catch (error: any) {
      console.error("Error submitting inventory:", error.message);
    }
  };

  const handleDeleteInventory = async (id: number) => {
    try {
      await api(`/update-inventory/${id}`, { method: "DELETE" });
      fetchInventoryData();
      await refreshLifecycleProgress();
    } catch (error) {
      console.error("Error deleting inventory");
    }
  };
  const inventoryOptions: InventoryOption[] = inventoryType.map((item) => ({
    value: item.id.toString(), // make sure it's string
    label: `${item.device_code} | ${item.type} | ${item.brand} | ${item.description} | ${item.configuration}`,
  }));

  // --------- Shared fetchDocuments helper ----------
  const fetchDocuments = async (page: number = docPage) => {
    if (!selectedUserId) return;
    // Skip API call if role is "2"
    if (roleName == '2') return;
    try {
      const res = await api<{
        documents: {
          current_page: number;
          data: (DocumentItem & {
            document_submitted?: boolean | number;
            document_uploaded?: boolean | number;
          })[];
          total: number;
          per_page: number;
        };
      }>(`/employees/employeeDocument/${selectedUserId}?page=${page}`, {
        method: "POST",
      });

      const mappedDocs: DocumentItem[] = res.documents.data.map((d: any) => {
        const rawSubmitted = d.document_submitted;
        let normalizedSubmitted: boolean | undefined;
        if (rawSubmitted === 1 || rawSubmitted === "1" || rawSubmitted === true) {
          normalizedSubmitted = true;
        } else if (
          rawSubmitted === 0 ||
          rawSubmitted === "0" ||
          rawSubmitted === false
        ) {
          normalizedSubmitted = false;
        } // else leave as undefined

        return {
          id: d.id,
          emp_doc_id: d.emp_doc_id,
          document_type: d.document_type,
          document_path: d.document_path,
          document_number: d.document_number,
          document_submitted: normalizedSubmitted,
          document_uploaded:
            typeof d.document_uploaded === "number"
              ? d.document_uploaded === 1
              : !!d.document_uploaded,
        };
      });

      setDocuments(mappedDocs);
      setDocTotal(res.documents.total);
      setDocPerPage(res.documents.per_page);
      setDocPage(res.documents.current_page);
      setDocError(null);

      // One-time reminder per visit for active employees only:
      // show a toast only on the first successful load of this
      // module, and only for documents explicitly marked
      // as "Will submit later" (document_submitted === 0).
      if (
        !hasShownDocReminderRef.current &&
        isExitEmployee === false
      ) {
        // Mark as evaluated so later uploads/deletes won't trigger
        // new reminders during this visit.
        hasShownDocReminderRef.current = true;

        const pendingUploadedDocs = mappedDocs.filter(
          (d) => d.document_submitted === false
        );
        if (pendingUploadedDocs.length > 0) {
          const titles = pendingUploadedDocs
            .map((d) => d.document_type)
            .join(", ");
          toast.warn(
            `Reminder: Please upload the following documents: ${titles}`
          );
          hasShownDocReminderRef.current = true;
        }
      }
    } catch (err: any) {
      console.error(err);
      setDocError("Failed to load documents.");
    }
  };

  useEffect(() => {
    fetchDocuments(docPage);
  }, [selectedUserId, docPage]);
  const validateForm = () => {
    const errors: Record<string, string> = {};
    const contactStr = String(formData.contact || "");

    // Ensure all fields are properly checked before trimming
    if (!String(formData.name || "").trim()) errors.name = "Name is required.";
    if (!String(formData.email || "").trim()) errors.email = "Email is required.";
    else if (!/^\S+@\S+\.\S+$/.test(String(formData.email))) {
      errors.email = "Invalid email format.";
    }
    if (!formData.dob) errors.dob = "Date of Birth is required.";
    if (!contactStr.trim())
      errors.contact = "Contact Number is required.";
    else if (!/^\d{10}$/.test(contactStr)) {
      errors.contact = "Phone number must be 10 digits.";
    }
    if (!String(formData.gender || "").trim()) errors.gender = "Gender is required.";
    if (!String(formData.employmentStatus || "").trim())
      errors.employmentStatus = "Employment Status is required.";

    console.log("Validation errors:", errors);
    // Check if reportingHead is a valid string
    if (
      !formData.reportingHead ||
      typeof formData.reportingHead !== "string" ||
      !formData.reportingHead.trim()
    ) {
      errors.reportingHead = "Reporting Head is required.";
    }
    if (
      !formData.designation ||
      typeof formData.designation !== "string" ||
      !formData.designation.trim()
    ) {
      errors.designation = "Designation is required.";
    }

    if (!formData.joiningDate)
      errors.joiningDate = "Date of Joining is required.";
    if (!String(formData.userRole || "").trim()) errors.userRole = "User Role is required.";

     if (
      (["3", "4", "6"].includes(String(formData.employmentStatus))) &&
      !formData.leavingDate
    ) {
      errors.leavingDate = "Date of Leaving is required.";
    }

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };
  const fetchEmployees = async () => {
    try {
      const res: any = await api("/search-employee", {
        method: "POST",
        body: {
          currentPage,
          pageSize,
          designation: selectedDesignation ?? undefined,
          status: selectedStatus ?? undefined,
          // search: debouncedSearchTerm.trim() || undefined,
        },
      });

      setDesignationsList(
        res.data.map((rec: any) => ({
          id: rec.id,
          imageUrl: rec.image_url,
          name: rec.name,
          designation: { title: rec.designation.title },
          eId: rec.employee_id,
          phoneNumber: rec.phone_number,
          joinDate: formatJoinDate(rec.date_of_joining),
        }))
      );

      // if (Array.isArray(res.designations)) {
      //   setDesignationOptions(
      //     res.designations.map((d: any) => ({ label: d.title, value: d.id }))
      //   );
      // }

      // if (Array.isArray(res.designations)) {
      //   setModalDesignationOptions(
      //     res.designations.map((d: any) => ({ label: d.title, value: d.id }))
      //   );
      // }
      // if (res.status && typeof res.status === "object") {
      //   setStatusOptions(
      //     Object.entries(res.status).map(([k, v]) => ({
      //       label: v as string,
      //       value: k,
      //     }))
      //   );
      // }
      // if (res.status && typeof res.status === "object") {
      //   setModalStatusOptions(
      //     Object.entries(res.status).map(([k, v]) => ({
      //       label: v as string,
      //       value: k,
      //     }))
      //   );
      // }
      // if (Array.isArray(res.reporting_heads)) {
      //   setReportingHeadOptions(
      //     res.reporting_heads.map((head: any) => ({
      //       label: head.name,
      //       value: head.id,
      //       image: head.image_url, // Optional if you want to use image
      //     }))
      //   );
      // }

      // if (res.userrole && typeof res.userrole === "object") {
      //   setUserRoleOptions(
      //     Object.entries(res.userrole).map(([k, v]) => ({
      //       label: v as string,
      //       value: k,
      //     }))
      //   );
      // }
    } catch (err: any) {
      console.error("Fetch error:", err.message);
    }
  };

  const handleSubmit = async () => {
    console.log("handleSubmit called! Current form data state:", formData);

    if (!validateForm()) {
      console.log("Validation failed in handleSubmit! Blocking save.");
      toast.error("Please fill all required fields correctly to save.");
      return;
    }

    // Remember last persisted status so we can revert
    // the dropdown if lifecycle guards block a change.
    prevStatusRef.current = savedStatusValue;

    // Enforce onboarding status flow based on backend STATUS map:
    // PRE_JOINING (7) -> PROBATION (1) -> PERMANENT (2)
    // Only allow transitions that follow this order and
    // only when previous mandatory stages are complete.
    if (onboardingData && !isExitStatus(savedStatusValue)) {
      const statusStep = onboardingData.steps.find(
        (s) => s.key === "status"
      );
      const mandatorySteps = onboardingData.steps.filter((s) => s.mandatory);
      const completedMandatory = mandatorySteps.filter((s) => s.completed);

      const allMandatoryComplete =
        mandatorySteps.length > 0 &&
        mandatorySteps.length === completedMandatory.length;

      // If status step is not yet marked complete, prevent manually
      // changing employment status to a non pre-joining state.
      if (
        !allMandatoryComplete &&
        formData.employmentStatus &&
        formData.employmentStatus !== savedStatusValue
      ) {
        console.log("Blocked by onboarding guard: Not all mandatory steps complete before status change.");
        toast.error(
          "Complete all mandatory onboarding stages before changing status."
        );
        // Reset dropdown back to last saved value so UI and
        // lifecycle cards remain consistent.
        setFormData((prev) => ({
          ...prev,
          employmentStatus: savedStatusValue,
        }));
        return;
      }

      const isBackendPreJoining = employeeData?.is_active === -1 ;
      const documentsStep = onboardingData.steps.find((s) => s.key === "documents");
      const inductionStep = onboardingData.steps.find((s) => s.key === "induction");
      
      // check if any mandatory step till induction is incomplete
      const mandatoryIncomplete = onboardingData.steps
        .filter((s) => s.mandatory && ["documents", "team", "induction"].includes(s.key))
        .some((s) => !s.completed);
      
      // Prevent activation before onboarding completion
      if (
        isBackendPreJoining &&
        (formData.is_active === true || formData.is_active === 1 || formData.is_active === "1") &&
        (!documentsStep?.completed || mandatoryIncomplete || !inductionStep?.completed)
      ) {
        console.log("Blocked by activation guard: Attempted to mark active before onboarding is fully complete.");
        toast.error(
          "You cannot mark this employee as Active until mandatory onboarding steps (Documents, Team setup, and Induction) are completed."
        );
        return;
      }
    }

  



    // Exit flow: if backend status is Notice Period,
    // do not allow changing status until exit process is fully completed.
    const savedStatusLabel =
      modalStatusOptions.find((opt) => opt.value === savedStatusValue)
        ?.label || "";
    const isStatusChanging =
      formData.employmentStatus &&
      formData.employmentStatus !== savedStatusValue;
    const newStatusLabel =
      modalStatusOptions.find(
        (opt) => opt.value === formData.employmentStatus
      )?.label || "";

    const noticeToFinalTransition =
      isStatusChanging &&
      savedStatusLabel === "Notice Period" &&
      ["Released", "Terminated"].includes(newStatusLabel);

    // Prevent moving back to Pre‑Joining from any later stage.
    if (
      isStatusChanging &&
      newStatusLabel === "Pre-Joining" &&
      savedStatusLabel &&
      savedStatusLabel !== "Pre-Joining"
    ) {
      console.log("Blocked by status guard: Cannot revert back to Pre-Joining.");
      toast.error(
        "Cannot change status back to Pre-Joining once the employee has moved beyond that stage."
      );
      setFormData((prev) => ({
        ...prev,
        employmentStatus: savedStatusValue,
      }));
      return;
    }

    // Exit flow: if backend status is Notice Period,
    // do not allow changing status until exit process is fully completed.
    if (savedStatusLabel === "Notice Period" && isStatusChanging) {
      // If we don't yet know that exit is complete (or data is stale),
      // re-check the latest exit summary from the backend once before
      // deciding whether to block or allow the status change.
      let resolvedExit = exitData || null;
      if (!resolvedExit || !resolvedExit.summary?.isExitComplete) {
        try {
          const latest = await nodeApi<ExitResponse>("/employee/exit", {
            method: "POST",
            body: { userId: selectedUserId },
          });
          setExitData(latest);
          resolvedExit = latest;
        } catch (err) {
          // If the fresh check fails, treat it as not complete to be safe.
          console.warn("Failed to refresh exit summary before status change", err);
        }
      }

      const exitCompleteNow = !!resolvedExit?.summary?.isExitComplete;

      if (!exitCompleteNow) {
        console.log("Blocked by exit guard: Exit process is not completed yet.");
        toast.error(
          "Complete all exit stages and mark exit complete before changing status from Notice Period."
        );
        // Reset dropdown back to last saved value so the UI
        // does not remain on an invalid in‑between state.
        setFormData((prev) => ({
          ...prev,
          employmentStatus: savedStatusValue,
        }));
        return;
      }
    }

    // Finalized exit statuses: once Released or Terminated,
    // do not allow any further status changes.
    if (
      isStatusChanging &&
      ["Released", "Terminated"].includes(savedStatusLabel)
    ) {
      console.log("Blocked by exit guard: Cannot change status after employee is Released/Terminated.");
      toast.error(
        "Status cannot be changed after the employee is Released or Terminated."
      );
      setFormData((prev) => ({
        ...prev,
        employmentStatus: savedStatusValue,
      }));
      return;
    }
    

    console.log("All validations & lifecycle guards passed! Building payload...", formData);
    // 1. Normalize your dates
    const parseDate = (dateStr: string) => {
      const parsed = moment(
        dateStr,
        ["DD-MMM-YYYY", "YYYY-MM-DD", "DD-MM-YYYY"],
        true
      );
      return parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
    };

    const dobIso = dayjs(formData.dob).format("YYYY-MM-DD");
    const joiningIso = dayjs(formData.joiningDate).format("YYYY-MM-DD");
const leavingIso = formData.leavingDate
  ? dayjs(formData.leavingDate).format("YYYY-MM-DD")
  : "";
    const internshipIso = formData.internshipDate
      ? dayjs(formData.internshipDate).format("YYYY-MM-DD")
      : "";
    console.log("formdata", formData.internshipDate);
    console.log("internshipIso:", internshipIso);

    console.log("DOB Raw1:", formData.dob, "=> Parsed:", dobIso);
    console.log("DOJ Raw1:", formData.joiningDate, "=> Parsed:", joiningIso);

    // 2. Build FormData
    const payload = new FormData();
    payload.append("date_of_birth", dobIso);
    payload.append("date_of_joining", joiningIso);
    if (isExitStatus(formData.employmentStatus)) {
      payload.append("date_of_leaving", leavingIso);
    }
    payload.append("date_of_internship", internshipIso);
    payload.append("empid", formData.employee_id);
    payload.append("id", formData.id);
    payload.append("name", formData.name);
    payload.append("email", formData.email);
    payload.append("phone_number", formData.contact);
    // map your gender value to whatever the API expects (e.g. "1" or "2")
    payload.append("gender", formData.gender || "");
    payload.append("pan_number", formData.pan);
    if (formData.photo) payload.append("photo", formData.photo);
    payload.append("address", formData.address);
    payload.append("status", formData.employmentStatus);
    payload.append("designation_id", formData.designation);
    payload.append("reporting_head", formData.reportingHead);
    payload.append("role_name", formData.userRole);
    payload.append("password", formData.password);
    
    const isBackendPreJoining = employeeData?.is_active === -1 || employeeData?.is_active === "-1";
    if (isBackendPreJoining && !isOnboardingFullyComplete) {
      payload.append("is_active", "-1");
    } else {
      payload.append(
        "is_active", 
        (formData.is_active === true || formData.is_active === 1 || formData.is_active === "1") ? "1" : "0"
      );
    }
    payload.append("flag", formData.flag ? "1" : "0");
    payload.append("account_number", formData.accountNumber);
    payload.append("account_name", formData.accountName);
    payload.append("branch_name", formData.branchName);
    payload.append("ifsc", formData.ifscCode);
    // boolean → "1"/"0"
    payload.append(
      "by_pass_attendance_check",
      formData.bypassAttendance ? "1" : "0"
    );
    payload.append("is_permenant_wfh", formData.permanentWfh ? "1" : "0");
    console.log("DOB Raw2:", formData.dob, "=> Parsed:", dobIso);
    console.log("DOJ Raw2:", formData.joiningDate, "=> Parsed:", joiningIso);

  try {
      setisSaving(true);
      console.log("Dispatching payload to API /employees/saveEmployee:", Object.fromEntries(payload.entries()));

      // 3. Send the FormData
      const body: any = { title: formData.designation.trim() };
      if (modalMode === "edit" && editId != null) body.id = editId;
      const res: any = await api("/employees/saveEmployee", {
        method: "POST",
        body: payload,
        // do NOT set Content-Type header—let fetch / your helper do it
      });
      toast.success(res.message);
      if (noticeToFinalTransition) {
        toast.success("Exit process is completed for this employee.");
      }

      // Update new employee_id from backend (if changed)
      if (res?.data?.employee_id) {
        setFormData((prev) => ({
          ...prev,
          employee_id: res.data.employee_id,
        }));

        setEmployeeData((prev) =>
          prev
            ? {
                ...prev,
                employee_id: res.data.employee_id,
                // Keep backing status in sync with the just-saved value
                // so lifecycle UI and EmployeeImage rely on persisted status.
                employment_status: formData.employmentStatus,
              }
            : null
        );
      }

      // Update exit/active flag based on the newly saved status
      // so onboarding vs exit flows line up with lifecycle APIs.
      const newStatusLabel =
        modalStatusOptions.find(
          (opt) => opt.value === formData.employmentStatus
        )?.label || "";
      const isNowExit = ["Notice Period", "Released", "Terminated"].includes(
        newStatusLabel
      );
      setIsExitEmployee(isNowExit);

      // If employee is in Notice Period, or was moved straight to
      // Released/Terminated (skipping Notice Period), and a leaving
      // date is set, sync it via the Node exit API so exit progress
      // (which reads date_of_leaving from that same column) reflects it.
      const currentStatusLabel =
        modalStatusOptions.find(
          (opt) => opt.value === formData.employmentStatus
        )?.label || "";
      if (
        ["Notice Period", "Released", "Terminated"].includes(
          currentStatusLabel
        ) &&
        formData.leavingDate &&
        selectedUserId
      ) {
        try {
          const lastWorkingDay = dayjs(formData.leavingDate).format(
            "DD-MM-YYYY"
          );
          await nodeApi("/employee/exit/lwd", {
            method: "POST",
            body: {
              userId: selectedUserId,
              lastWorkingDay,
            },
          });
        } catch (lwdErr: any) {
          const msg =
            lwdErr?.response?.data?.error ||
            lwdErr?.message ||
            "Failed to update last working day for exit process.";
          toast.error(msg);
        }
      }

      await refreshLifecycleProgress();
      fetchEmployees();
    } catch (err: any) {
  const message =
    err?.response?.data?.message ||
    err?.message ||
    "Failed to save employee";

  toast.error(message);

  // Reset status to previous value
  if (message.includes("Trainee")) {
    setFormData((prev) => ({
      ...prev,
      employmentStatus: prevStatusRef.current,
    }));
  }
} finally {
      setisSaving(false);
    }
  };

  // Auto-save after onboarding complete: when onOnboardingComplete sets
  // the password and flips submitAfterOnboardingRef, call handleSubmit.
  useEffect(() => {
    console.log("Auto-save Effect triggered. Checking conditions:", {
      refFlag: submitAfterOnboardingRef.current,
      hasPassword: !!formData.password
    });

    if (!submitAfterOnboardingRef.current) return;
    if (!formData.password) {
      console.log("Auto-save waiting... Password has not populated in formData yet.");
      return;
    }
    console.log("Auto-save proceeding! Calling handleSubmit().");
    submitAfterOnboardingRef.current = false;
    handleSubmit();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.password, formData.is_active, onboardingMarkedComplete]);

  const [formError, setFormError] = useState("");
  const [editId, setEditId] = useState<number | null>(null);
  const [modalMode, setModalMode] = useState<"add" | "edit">("add");

  const formatJoinDate = (d: string) => {
    const [day, month, year] = d.split("-");
    const names = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ];
    return `${day}-${names[+month - 1]}-${year}`;
  };
  const emptyForm = {
    name: "",
    email: "",
    dob: "",
    is_active: false,
    contact: "",
    gender: "",
    pan: "",
    photo: "",
    address: "",
    password: "",
    employmentStatus: "",
    joiningDate: "",
    designation: "",
    reportingHead: "",
    userRole: "",
    bypassAttendance: false,
    permanentWfh: false,
    accountNumber: "",
    accountName: "",
    branchName: "",
    ifscCode: "",
  };

  const isOnboardingFullyComplete =
    !!onboardingData &&
    !!onboardingData.summary?.isComplete &&
    (!!onboardingData.summary?.isOnboardingComplete || 
     !!onboardingData.summary?.onboardingMarkedComplete || 
     onboardingMarkedComplete);

  // Backend-saved employment status value (string), used for
  // lifecycle UI so dropdown edits do not affect cards until save.
  const savedStatusValue =
    employeeData?.employment_status != null
      ? employeeData.employment_status.toString()
      : "";

  // Helper to resolve the most up‑to‑date employment status value/label
  const getEffectiveStatusValue = () =>
    formData.employmentStatus ||
    (employeeData?.employment_status != null
      ? employeeData.employment_status.toString()
      : "");

  const getEffectiveStatusLabel = () => {
    const value = getEffectiveStatusValue();
    return (
      modalStatusOptions.find((opt) => opt.value === value)?.label || ""
    );
  };

  // For Pre-Joining employees, keep is_active unchecked until onboarding
  // is fully complete, then auto-check it.
// Effect to transition from "Pre-Joining" (-1) to "Active" (1/true)
useEffect(() => {
  /**
   * CHANGE: If onboarding is complete, we transition the state.
   * This turns the badge into a checkbox automatically in the UI.
   */
    if (isOnboardingFullyComplete && (formData.is_active === -1 || formData.is_active === "-1")) {
    setFormData(prev => ({
      ...prev,
      is_active: true // Setting to true switches UI from badge to checkbox
    }));
  }
}, [isOnboardingFullyComplete, formData.is_active]);

  const fetchLeaveBalance = async (page: number) => {
    if (!selectedUserId) return;
    if (roleName == '2') return;
    try {
      // send page in the query string, not the POST body
      const res = await api<{
        leave: {
          current_page: number;
          data: LeaveItem[];
          total: number;
          per_page: number;
        };
      }>(`/show-leave-balance`, {
        method: "POST",
        // you can still pass the body if you need the user ID in the payload
        body: { currentPage: page, id: selectedUserId },
      });

      setLeaveItems(res.leave.data);
      setLeaveTotalItems(res.leave.total);
      setLeavePerPage(res.leave.per_page); // ← pull from API
      setLeaveError(null);
    } catch (err: any) {
      console.error(err);
      setLeaveError("Failed to load leave balance.");
    }
  };

  useEffect(() => {
    fetchLeaveBalance(leavePage);
  }, [selectedUserId, leavePage]);

  // Pagination Handlers
  const handlePageChange = (page: number) => setCurrentPage(page);
  const handleLeavePageChange = (page: number) => setLeaveCurrentPage(page);

  // Document Form Handlers
  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, files } = e.target;
    const newValue = files?.[0] ?? value;

    // Update form state
    setDocumentForm((prev: any) => ({
      ...prev,
      [name]: newValue,
    }));

    // Clear error for this field when it's being changed
    setFormErrors((prev: any) => ({
      ...prev,
      [name]: undefined,
    }));
  };
const fetchOnboardingProgress = async () => {
  if (!selectedUserId) return;

  const res = await nodeApi<OnboardingResponse>("/employee/onboarding", {
    method: "POST",
    body: { userId: selectedUserId },
  });

  setOnboardingData(res);

 const serverMarked = !!(res.summary?.onboardingMarkedComplete || res.summary?.isOnboardingComplete);
  const localKey = `onboardingComplete:${res.employeeId}`;
  const localMarked = localStorage.getItem(localKey) === "1";

  setOnboardingMarkedComplete(serverMarked || localMarked);
};

const refreshLifecycleProgress = async () => {
  if (!selectedUserId) return;

  try {
    const effectiveStatusValue =
      formData.employmentStatus ||
      (employeeData?.employment_status != null
        ? employeeData.employment_status.toString()
        : "");

    const effectiveStatusLabel =
      modalStatusOptions.find((opt) => opt.value === effectiveStatusValue)
        ?.label || "";

    if (["Notice Period", "Released", "Terminated"].includes(effectiveStatusLabel)) {
      const res = await nodeApi<ExitResponse>("/employee/exit", {
        method: "POST",
        body: { userId: selectedUserId },
      });

      setExitData(res);

      if (res.summary?.status != null) {
        const newStatusValue = res.summary.status.toString();
        setEmployeeData((prev) =>
          prev
            ? {
                ...prev,
                employment_status: newStatusValue,
                is_active:
                  res.summary.isActive != null
                    ? res.summary.isActive
                    : prev.is_active,
              }
            : prev
        );
        setFormData((prev) => ({
          ...prev,
          employmentStatus: newStatusValue,
          is_active:
            res.summary.isActive != null ? res.summary.isActive : prev.is_active,
        }));
      }

    } else {
      setExitData(null);
      await fetchOnboardingProgress();
      await fetchInductionChecklist();
    }

  } catch (err: any) {
    const status = err?.response?.status;
    const message =
      err?.response?.data?.error ||
      err?.message ||
      "Failed to load lifecycle progress.";

    if (
      status === 400 &&
      typeof message === "string" &&
      message.toLowerCase().includes("date of leaving")
    ) {
      toast.error(message);
    } else {
      console.warn("Lifecycle progress refresh failed", err);
    }

    setExitData(null);
  }
};

const fetchInductionChecklist = async () => {
  if (!selectedUserId) return;

  try {
    setInductionLoading(true);

    const res = await nodeApi<{ data: InductionItem[] }>(
      "/employee/induction-checklist",
      {
        method: "POST",
        body: { userId: selectedUserId },
      }
    );

    const items = res.data || [];
    setInductionData(items);

    // Determine whether all induction checklist items are completed
    const summary: any = (res as any).summary;
    let allCompleted = false;

    if (
      summary &&
      typeof summary.completedActive === "number" &&
      typeof summary.active === "number" &&
      summary.active > 0
    ) {
      allCompleted = summary.completedActive === summary.active;
    } else {
      allCompleted = items.length > 0 && items.every((item) => item.completed);
    }

    // No API call here anymore.
    // Backend onboarding logic will automatically trigger
    // the policy email once induction + previous stages are complete.

  } catch (error) {
    console.error("Error fetching induction checklist", error);
  } finally {
    setInductionLoading(false);
  }
};

  const handleSubmitModal = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormErrors({});

    // Validate file selection only when user marks as submitted.
    if (documentSubmitted !== false) {
      if (
        !documentForm.document_path ||
        !(documentForm.document_path instanceof File)
      ) {
        setFormErrors((prev) => ({
          ...prev,
          document_path: "Please select a file to upload.",
        }));
        return;
      }
    }

    const formData = new FormData();
    formData.append("document_id", String(documentForm.document_id));
    formData.append(
      "emp_document_id",
      documentForm.emp_document_id != null
        ? String(documentForm.emp_document_id)
        : ""
    );
    formData.append("employee_id", String(selectedUserId));
    formData.append("document_number", documentForm.document_number || "");
    if (documentSubmitted !== null) {
      formData.append(
        "document_submitted",
        documentSubmitted ? "1" : "0"
      );
    }
    if (documentForm.document_path instanceof File) {
      formData.append(
        "document_path",
        documentForm.document_path,
        documentForm.document_path.name
      );
    }

    try {
      const token = localStorage.getItem("token") || "";
      const res = await fetch(
        `${REACT_APP_API_BASE_URL}/employees/saveDocument`,
        {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        }
      );
      if (!res.ok) throw new Error(await res.text());
      setShowModal(false);
      // reload page 1 so new upload appears immediately
      await fetchDocuments(1);
      await refreshLifecycleProgress();
      setCurrentPage(1);
    } catch (error) {
      console.error(error);
      setDocError("Upload Failed");
    }
  };

  const handleCloseModal = () => {
    setShowModal(false); // close modal immediately

    // Clear validation messages after delay
    setTimeout(() => {
      setFormErrors({});
      setDocumentForm((prev: any) => ({
        ...prev,
        document_path: null, // optionally reset file input
      }));
    }, 300); // Adjust delay to match modal closing animation
  };

  const handleView = async (path: string) => {
    try {
      const token = localStorage.getItem("token") || "";
      const res = await fetch(
        `${REACT_APP_API_BASE_URL}/show-document/${selectedUserId}/${path}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (!res.ok) throw new Error(res.statusText);
      const blob = await res.blob();
      window.open(URL.createObjectURL(blob));
    } catch (err: any) {
      console.error(err);
      setDocError("An error occurred while viewing.");
    }
  };

  const handleDownload = (docId: number) => {
  try {
    const token = localStorage.getItem("token") || "";

    // Browser-native download (NO blob)
    const downloadUrl =
      `${REACT_APP_API_BASE_URL}/documents/download/${docId}?token=${token}`;

    window.location.href = downloadUrl;

  } catch (err) {
    console.error("Download Error:", err);
    setDocError("An error occurred while downloading.");
  }
};

  const fetchCTCData = async (page: number) => {
    if (!selectedUserId) return;
    // Skip API call if role is "2"
    if (roleName == '2') return;
    setCtcErrors({});

    try {
      const res = (await api<{
        salarydetails: { data: CTCItem[]; total: number };
        payheads: Array<{ code: string; name: string /* … */ }>;
      }>(`/ctc-details/${selectedUserId}?page=${page}`, {
        method: "POST",
      })) as any;

      // 1) Process your existing CTC rows as before
      const mappedData: CTCItem[] = res.salarydetails.data.map((item: any) => ({
        id: item.id,
        from_date: moment(item.from_date).format("DD-MMM-YYYY"),
        to_date: item.to_date ? moment(item.to_date).format("DD-MMM-YYYY") : "",
        ctc: item.cost_to_company,
      }));
      setCTCData(mappedData);
      setTotalItems(res.salarydetails.total);

      // 2) Here’s the critical part: copy the payheads array into state
      console.log(" raw payhead array:", res.payhead);
      if (Array.isArray(res.payhead)) {
        setPayheadData(
          res.payhead.map((ph: any) => ({
            code: ph.code,
            name: ph.name,
            category: ph.category,
            description: ph.description
          }))
        );
      } else {
        // if your API nested it somewhere else, adjust accordingly
        console.warn("Payheads was not an array:", res.payheads);
      }
    } catch (error: any) {
      console.error("Error loading CTC + payheads:", error);
      setCtcErrors(error.message || "Failed to fetch CTC data.");
    } finally {
      // setLoadingCTC(false);
    }
  };


const triggerAttendanceAnalysis = async () => {
  try {
    setAnalysisLoading(true);
    setAnalysisResult(null);
    setAnalysisProgress(0);
    setAnalysisStatus("running");

    const res = await fetch(
       `${REACT_APP_ANALYSIS_API_BASE_URL}/api/v1/attendance/trigger_analysis`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          from_date: analysisFromDate!.format("YYYY-MM-DD"),
          to_date: analysisToDate!.format("YYYY-MM-DD"),
          employee_id: selectedUserId.toString(),
        }),
      }
    );

    const data = await res.json();

    //Handle ALL backend validation errors
    if (!data.success) {
      stopAnalysisWithError(data.error || data.message);
      return;
    }

    setAnalysisId(data.analysis_id);
    startAnalysisPolling(data.status_url, data.results_url);
  } catch (err: any) {
    stopAnalysisWithError("Failed to start analysis");
  }
};



const startAnalysisPolling = (statusUrl: string, fallbackResultsUrl: string) => {
  if (analysisPollRef.current) {
    clearInterval(analysisPollRef.current);
  }

  analysisPollRef.current = setInterval(async () => {
    try {
      const res = await fetch(
        `${REACT_APP_ANALYSIS_API_BASE_URL}${statusUrl}`
      );

      const data = await res.json();

      //  Backend error case
      if (!data.success) {
        stopAnalysisWithError(data.error || data.message);
        return;
      }

      //  ML runtime error case
      if (data.status === "error") {
        stopAnalysisWithError(data.message);
        return;
      }

      setAnalysisStatus(data.status);
      setAnalysisProgress(data.progress || 0);

      //  Completed
      if (data.status === "completed") {
        clearInterval(analysisPollRef.current!);
        analysisPollRef.current = null;

        setAnalysisLoading(false);
        toast.success(
          `Attendance analysis completed for ${analysisFromDate?.format(
            "DD MMM YYYY"
          )} to ${analysisToDate?.format("DD MMM YYYY")}`,
          { autoClose: 4000 }
        );

        fetchAnalysisResult(
          data.results_url || fallbackResultsUrl
        );
      }
    } catch {
      stopAnalysisWithError("Failed to fetch analysis status");
    }
  }, 3000);
};




const fetchAnalysisResult = async (resultsUrl: string) => {
  try {
    const res = await fetch(
      `${REACT_APP_ANALYSIS_API_BASE_URL}${resultsUrl}`
    );

    const data = await res.json();

    if (!data.success) {
      stopAnalysisWithError(data.error || data.message);
      return;
    }

    setAnalysisResult(data);
  } catch (err: any) {
    stopAnalysisWithError("Error fetching analysis results");
  }
};



useEffect(() => {
  return () => {
    if (analysisPollRef.current) {
      clearInterval(analysisPollRef.current);
    }
  };
}, []);


  useEffect(() => {
    fetchCTCData(currentPage);
    console.log("Fetching CTC data:", selectedUserId, currentPage, pageSize);
  }, [selectedUserId, currentPage]);

  const handleDownloadCTCExcel = async () => {
    const employeeCode = employeeData?.employee_id; // from EmployeeData
    const employeeName = employeeData?.name;
    try {
      const res = await api("/download-ctc-excel", {
        method: "POST",
        body: { id: selectedUserId },
        responseType: "blob",
      });

      const blob = new Blob([res as any], { type: "application/vnd.ms-excel" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${employeeCode}_${employeeName}_CTC_Report.xlsx`;
      link.click();
    } catch (error: any) {
      console.error("Download error:", error);
    }
  };
  const calculateSalary = async (passedCtc?: string) => {
    const ctcToUse = passedCtc ?? ctc;
    try {
      const res = (await api("/calculate-salary", {
        method: "POST",
        body: { ctc: ctcToUse },
      })) as {
        monthly: Record<string, any>;
        annual: Record<string, any>;
        originalSA: string;
      };
      
      setGross(res.monthly.gross);
      setAnnextureBtotal(res.monthly.AnnextureBTotal);
      setTotalDeduction(res.monthly.totalDeduction);
      setMonthCTC(Math.round(Number(ctcToUse) / 12).toString())
      setBasicSalary(res.monthly.Basic);
      sethouseRent(res.monthly.HRA);
      setTravelAllowance(res.monthly.TA);
      setMedicalAllowance(res.monthly.MA);
      setProfessionalTax(res.monthly.PT);

      setSecurityDeposit(res.monthly.SD);
      setSpecialAllowance(res.monthly.SA);
      setCityCompensatoryAllowance(res.monthly.CAA);
      setleaveTravel(res.monthly.LTA);
      setMobileInternet(res.monthly.MIA);
      setTds(res.monthly.TDS);
      setBasic(res.monthly.asdf);

      setBasicSalaryAnnual(res.annual.Basic);
      sethouseRentAnnual(res.annual.HRA);
      setTravelAllowanceAnnual(res.annual.TA);
      setMedicalAllowanceAnnual(res.annual.MA);
      setProfessionalTaxAnnual(res.annual.PT);
      setSecurityDepositAnnual(res.annual.SD);
      setSpecialAllowanceAnnual(res.annual.SA);
      setCityCompensatoryAllowanceAnnual(res.annual.CAA);
      setleaveTravelAnnual(res.annual.LTA);
      setMobileInternetAnnual(res.annual.MIA);
      setTdsAnnual(res.annual.TDS);
      setBasicAnnual(res.annual.asdf);

      setNetSalary(res.monthly.netSalary);
      setNetSalaryAnnual(res.annual.annualSalary);
      setPayheadValues(res.monthly);
      setOriginalSA(res.originalSA);
    } catch (error) {
      console.error("Error calculating salary:", error);
    }
  };

  const recalculateSalary = async () => {
    console.log("Recalculating salary with payhead values:", payheadValues);
    try {
      const res = (await api("/recalculate-salary", {
        method: "POST",
        body: { payheadValues,ctc },
      }))as {
        monthly: Record<string, any>;
        annual: Record<string, any>;
        originalSA: string;
      };

      setGross(res.monthly.gross);
      setAnnextureBtotal(res.monthly.AnnextureBTotal);
      setTotalDeduction(res.monthly.totalDeduction);
      setMonthCTC(Math.round(Number(ctc) / 12).toString())
      setBasicSalary(res.monthly.Basic);
      sethouseRent(res.monthly.HRA);
      setTravelAllowance(res.monthly.TA);
      setMedicalAllowance(res.monthly.MA);
      setProfessionalTax(res.monthly.PT);

      setSecurityDeposit(res.monthly.SD);
      setSpecialAllowance(res.monthly.SA);
      setCityCompensatoryAllowance(res.monthly.CAA);
      setleaveTravel(res.monthly.LTA);
      setMobileInternet(res.monthly.MIA);
      setTds(res.monthly.TDS);
      setBasic(res.monthly.asdf);

      setBasicSalaryAnnual(res.annual.Basic);
      sethouseRentAnnual(res.annual.HRA);
      setTravelAllowanceAnnual(res.annual.TA);
      setMedicalAllowanceAnnual(res.annual.MA);
      setProfessionalTaxAnnual(res.annual.PT);
      setSecurityDepositAnnual(res.annual.SD);
      setSpecialAllowanceAnnual(res.annual.SA);
      setCityCompensatoryAllowanceAnnual(res.annual.CAA);
      setleaveTravelAnnual(res.annual.LTA);
      setMobileInternetAnnual(res.annual.MIA);
      setTdsAnnual(res.annual.TDS);
      setBasicAnnual(res.annual.asdf);

      setNetSalary(res.monthly.netSalary);
      setNetSalaryAnnual(res.annual.annualSalary);
      setPayheadValues(res.monthly);
      setOriginalSA(res.originalSA);
    } catch (error) {
      console.error("Error recalculating salary:", error);
    }
  };

  const recalculateSA = () => {
    const CCA = payheadValues["CCA"] || 0;
    const originalCCA = Number(cityCompensatoryAllowance) || 0;
    const LTA = payheadValues["LTA"] || 0;
    const originalLTA = Number(leaveTravel) || 0;
    const MIA = payheadValues["MIA"] || 0;
    const originalMIA = Number(mobileInternet) || 0;
    const originalSa = parseFloat(originalSA) || 0;
    const original = originalSa + originalCCA + originalLTA + originalMIA;
    const SA = original - CCA - LTA - MIA;

    setPayheadValues((prev) => ({ ...prev, SA: SA > 0 ? SA : 0 }));
  };

  const handleDateChange = (date: Date | null) => {
    setFromDate(date);
  };

  const handleSubmitStructure = async () => {
    const errors: { ctc?: string; fromDate?: string } = {};
    if (!ctc) errors.ctc = "CTC is required";
    if (!fromDate) errors.fromDate = "From Date is required";
    if (Object.keys(errors).length > 0) {
      setCtcErrors(errors);
      modalRef.current?.scrollTo({ top: 0, behavior: "smooth" });
      setTimeout(() => setCtcErrors({}), 3000);
      return;
    }
    const payload = {
      employee_id: selectedUserId,
      ctc,
      gross,
      monthCTC,
      fromDate: fromDate ? dayjs(fromDate).format("YYYY-MM-DD") : "",
      payhead: payheadValues,
      netSalary,
      ...(editingCTC && { ctc_id: ctcId }),
    };
    if (editingCTC) {
      payload.ctc_id = ctcId;
    }
    try {
      const response = (await api("/save-salary-structure", {
        method: "POST",
        body: payload,
      })) as any;
      resetSalaryFields();
      setShowCTCModal(false);
      fetchCTCData(1);
      await refreshLifecycleProgress();
    } catch (error: any) {
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        "An error occurred. Please try again.";
      toast.error(msg);
      console.error("Caught error:", msg);
    }
  };
useEffect(() => {
  if (showCTCModal) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }

  // Cleanup to restore scroll when component unmounts
  return () => {
    document.body.style.overflow = "";
  };
}, [showCTCModal]);
  const openAddCTCModal = () => {
    setEditingCTC(false); // Ensure it's in Add mode
    setCTCId(null); // Reset the edit ID
    setShowCTCModal(true); // Open modal

    // Reset all form values
    setCtc("");
    setGross("");
    setAnnextureBtotal("");
    setTotalDeduction("");
    setMonthCTC("");
    setNetSalary("");
    setFromDate(null);

    setBasic("");
    sethouseRent("");
    setTravelAllowance("");
    setMedicalAllowance("");
    setProfessionalTax("");
    setSecurityDeposit("");
    setSpecialAllowance("");
    setCityCompensatoryAllowance("");
    setleaveTravel("");
    setMobileInternet("");
    setTds("");

    setBasicAnnual("");
    sethouseRentAnnual("");
    setTravelAllowanceAnnual("");
    setMedicalAllowanceAnnual("");
    setProfessionalTaxAnnual("");
    setSecurityDepositAnnual("");
    setSpecialAllowanceAnnual("");
    setCityCompensatoryAllowanceAnnual("");
    setleaveTravelAnnual("");
    setMobileInternetAnnual("");
    setTdsAnnual("");
    setNetSalaryAnnual("");

    setPayheadValues({});
    // setEditingCTC(false);
    // setCTCId(null);
    // setShowCTCModal(true);
  };

  const handleEditCTC = async (id: number) => {
    try {
      const res = await api(`/edit-salary-structure/${id}`, {
        method: "POST",
      });

      // Populate modal form with res if needed
      //   setEditingCTC(true);
      //   setCTCId(id);
      //   setShowCTCModal(true);

      const data = res as any;
      console.log("Edit response:", res);

      // Enable editing mode and open modal
      setEditingCTC(true);
      setCTCId(id);

      // Set flat fields
      setCtc(data.salarydetails?.cost_to_company?.toString() || "");
      setGross(data.gross?.toString() || "");
      setMonthCTC(data.salarydetails?.ctcMonth?.toString() || "");
      setAnnextureBtotal(data.totalB?.toString() || "");
      setTotalDeduction(data.totalDeduction?.toString() || "");
      console.log("ctc month",data.ctcMonth?.toString());
      setIsLatest(data.islatest);
      setNetSalary(data.netsalary?.toString() || "");
      setBasic(data.payheadvalues?.Basic || "");
      setFromDate(dayjs(data.salarydetails?.from_date || null));

      // Monthly payhead values
      setPayheadValues(data.payheadvalues || {});
      setBasicSalary(data.payheadvalues?.Basic || "");
      sethouseRent(data.payheadvalues?.HRA || "");
      setTravelAllowance(data.payheadvalues?.TA || "");
      setMedicalAllowance(data.payheadvalues?.MA || "");
      setProfessionalTax(data.payheadvalues?.PT || "");
      setSecurityDeposit(data.payheadvalues?.SD || "");
      setSpecialAllowance(data.payheadvalues?.SA || "");
      setCityCompensatoryAllowance(data.payheadvalues?.CCA || "");
      setleaveTravel(data.payheadvalues?.LTA || "");
      setMobileInternet(data.payheadvalues?.MIA || "");
      setTds(data.payheadvalues?.TDS || "");

      // Annual payhead values
      setBasicAnnual(data.annualpayheadvalues?.Basic?.toString() || "");
      sethouseRentAnnual(data.annualpayheadvalues?.HRA?.toString() || "");
      setTravelAllowanceAnnual(data.annualpayheadvalues?.TA?.toString() || "");
      setMedicalAllowanceAnnual(data.annualpayheadvalues?.MA?.toString() || "");
      setProfessionalTaxAnnual(data.annualpayheadvalues?.PT?.toString() || "");
      setSecurityDepositAnnual(data.annualpayheadvalues?.SD?.toString() || "");
      setSpecialAllowanceAnnual(data.annualpayheadvalues?.SA?.toString() || "");
      setCityCompensatoryAllowanceAnnual(
        data.annualpayheadvalues?.CCA?.toString() || ""
      );
      setleaveTravelAnnual(data.annualpayheadvalues?.LTA?.toString() || "");
      setMobileInternetAnnual(data.annualpayheadvalues?.MIA?.toString() || "");
      setTdsAnnual(data.annualpayheadvalues?.TDS?.toString() || "");
      setNetSalaryAnnual(data.annualsalary?.toString() || "");
      setOriginalSA(data.originalSA);
      setShowCTCModal(true);
    } catch (error: any) {
      console.error("Edit fetch error:", error.message);
    }
  };

  const handleDeleteStructure = async (id: number) => {
    try {
      await api(`/delete-salary-structure/${id}`, { method: "POST" });
      fetchCTCData(currentPage);
      await refreshLifecycleProgress();
    } catch (error: any) {
      console.error("Delete error:", error.message);
    }
  };

  const openDeleteStructureModal = (id: number) => {
    setStructureToDeleteId(id);
    setShowDeleteModal1(true);
  };

  const closeDeleteModal1 = () => {
    setShowDeleteModal1(false);
    setStructureToDeleteId(null);
  };
  const handleConfirmedDeleteStructure = () => {
    if (structureToDeleteId !== null) {
      handleDeleteStructure(structureToDeleteId);
    }
    closeDeleteModal1();
  };

  const openModal = (doc: DocumentItem) => {
    setDocumentForm({
      document_id: doc.id,
      emp_document_id: doc.emp_doc_id,
      employee_id: selectedUserId,
      document_number: doc.document_number ?? "",
      document_path: null,
    });
    setIsEditing(!!doc.emp_doc_id);
    if (typeof doc.document_submitted === "boolean") {
      setDocumentSubmitted(doc.document_submitted);
    } else if (doc.document_path) {
      setDocumentSubmitted(true);
    } else if (doc.emp_doc_id && !doc.document_path) {
      setDocumentSubmitted(false);
    }
    else {
      setDocumentSubmitted(null);
    }
    setShowModal(true);
  };
  const closeModal = () => setShowModal(false);

  const openDeleteModal = (emp_doc_id: number) => {
    setDocumentToDeleteId(emp_doc_id);
    setShowDeleteModal(true);
  };
  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setDocumentToDeleteId(null);
  };
  const handleDeleteDocument = async () => {
    if (!documentToDeleteId) return;
    try {
      await api("/document/delete", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: {
          emp_document_id: documentToDeleteId,
          employee_id: selectedUserId.toString(),
        },
      });
      setShowDeleteModal(false);
      // refresh current page to remove deleted row
      await fetchDocuments(currentPage);
      await fetchOnboardingProgress(); // to update document submission status in lifecycle
      await refreshLifecycleProgress();
    } catch (err: any) {
      console.error(err);
      setDocError("Failed to delete.");
    }
  };

  const documentColumns = [
    { title: "Title", dataIndex: "document_type", key: "document_type" },
   {
  title: "File",
  dataIndex: "document_path",
  key: "document_path",
  render: (path: string | null, rec: DocumentItem) => {

    // CASE 1 → Uploaded document
    if (path && rec.document_submitted !== false) {
      return (
        <>
          <button
            className="btn btn-link"
            onClick={() => handleView(path)}
            title="View"
          >
            {renderIcon(FaEye)}
          </button>

          {" | "}

          <button
            className="btn btn-link"
            onClick={() => handleDownload(rec.emp_doc_id)}
            title="Download"
          >
            {renderIcon(FaDownload)}
          </button>
        </>
      );
    }

    // CASE 2 → Will submit later
    if (rec.document_submitted !== true && rec.emp_doc_id) {
      return (
        <button
          className="btn btn-link text-info"
          title="Employee will submit later"
          onClick={() =>
            toast.info("Employee will submit this document later to HR.")
          }
        >
          {renderIcon(FaInfoCircle)}
        </button>
      );
    }

    // CASE 3 → Not uploaded yet
    return <span>-</span>;
  },
},
   {
  title: "Action",
  key: "action",
  render: (_: any, rec: DocumentItem) => {

    // Uploaded OR Submit Later → Edit + Delete
    if (rec.emp_doc_id) {
      return (
        <>
          <button
            className="btn btn-link"
            onClick={() => openModal(rec)}
            title="Edit"
          >
            {renderIcon(FaEdit)}
          </button>

          <button
            className="btn btn-link text-danger"
            onClick={() => openDeleteModal(rec.emp_doc_id)}
            title="Delete"
          >
            {renderIcon(FaTrashAlt)}
          </button>
        </>
      );
    }

    // Not uploaded yet → Upload
    return (
      <button
        className="btn btn-link"
        onClick={() => openModal(rec)}
        title="Upload"
      >
        {renderIcon(FaCloudUploadAlt)}
      </button>
    );
  },
},
  ];

  const salaryStructure = [
    {
      title: "From Date",
      dataIndex: "from_date",
    },
    {
      title: "To Date",
      dataIndex: "to_date",
    },
    {
      title: "CTC",
      dataIndex: "ctc",
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (_: any, record: any) => (
        <>
          <button
            className="btn btn-icon btn-sm"
            title="Edit"
            onClick={() => handleEditCTC(record.id)}
          >
            <i className="fa fa-edit" />
          </button>
          <button
            className="btn btn-icon btn-sm"
            title="Delete"
            onClick={() => openDeleteStructureModal(record.id)}
          >
            <i className="fas fa-trash" />
          </button>
        </>
      ),
    },
  ];

  const leaveColumns = [
    // {
    //   title: "#",
    //   key: "rowNumber",
    //   width: 60,
    //   render: (_: any, __: any, idx: number) =>
    //     (leavePage - 1) * leavePerPage + idx + 1,
    // },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: 120,
      render: (d: string) => {
        const dt = new Date(d);
        const m = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        return `${String(dt.getDate()).padStart(2, "0")}-${
          m[dt.getMonth()]
        }-${dt.getFullYear()}`;
      },
    },
    {
      title: "Notes",
      dataIndex: "notes",
      key: "notes",
      render: (txt: string) => (
        <div
          style={{
            maxWidth: "200px",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 3,
            overflow: "hidden",
            wordWrap: "break-word",
            textOverflow: "ellipsis",
          }}
        >
          {txt}
        </div>
      ),
    },
    {
      title: "Leaves(+/-)",
      dataIndex: "no_of_leaves", // ← your API field
      key: "no_of_leaves",
      width: 100,
      align: "right",
      render: (n: number) => <span>{n > 0 ? `+${n}` : n}</span>,
    },
    {
      title: "Balance",
      dataIndex: "total_leaves", // ← your API field
      key: "total_leaves",
      width: 100,
      align: "right",
      render: (b: number) => b.toFixed(1),
    },
  ];

  const resetSalaryFields = () => {
    setGross("");
    setAnnextureBtotal("");
    setTotalDeduction("");
    setMonthCTC("");
    setCtc("");
    setNetSalary("");
    setBasicSalary("");
    sethouseRent("");
    setTravelAllowance("");
    setMedicalAllowance("");
    setProfessionalTax("");
    setSecurityDeposit("");
    setSpecialAllowance("");
    setCityCompensatoryAllowance("");
    setleaveTravel("");
    setMobileInternet("");
    setTds("");
    setBasic("");

    setBasicSalaryAnnual("");
    sethouseRentAnnual("");
    setTravelAllowanceAnnual("");
    setMedicalAllowanceAnnual("");
    setProfessionalTaxAnnual("");
    setSecurityDepositAnnual("");
    setSpecialAllowanceAnnual("");
    setCityCompensatoryAllowanceAnnual("");
    setleaveTravelAnnual("");
    setMobileInternetAnnual("");
    setTdsAnnual("");
    setBasicAnnual("");
    setNetSalaryAnnual("");

    setPayheadValues({});
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/** use backend-saved status for image and cards */}
          <EmployeeImage
            skipSaveApiCall={true}
            employeeId={selectedUserId}
            name={formData.name}
            designation={
              modalDesignationOptions.find(
                (opt) => opt.value === formData.designation
              )?.label || ""
            }
            imageUrl={formData.image_url}
            onboardingData={
              isExitStatus(savedStatusValue) ? null : onboardingData
            }
            onboardingMarkedCompleteProp={
              isExitStatus(savedStatusValue)
                ? false
                : onboardingMarkedComplete
            }
            onOnboardingRefresh={refreshLifecycleProgress}
            onOnboardingComplete={(pass) => {
              setFormData((prev) => ({
                ...prev,
                is_active: true,
                ...(pass ? { password: pass } : {}),
              }));
              submitAfterOnboardingRef.current = true;
            }}
            password={formData.password}
            employmentStatus={savedStatusValue}
            exitData={exitData}
            isActiveEmployee={formData.is_active === true || formData.is_active === 1 || formData.is_active === "1"}
          />
        {roleName == '1' &&
          onboardingData &&
          !onboardingMarkedComplete &&
          !onboardingData.summary?.isOnboardingComplete &&
          !exitData &&
          !isExitStatus(savedStatusValue) && (
          <div className="card mt-3 shadow-sm border-0">
            <div className="card-body d-flex justify-content-between align-items-center flex-wrap gap-2">
              <div>
                <div className="fw-semibold">Onboarding Status</div>
                {!onboardingMarkedComplete &&
                  !onboardingData.summary?.isComplete && (
                    <small className="text-muted">
                      {(employeeData?.is_active === -1 || employeeData?.is_active === "-1")
                        ? "Onboarding pending – finish all mandatory stages to mark as Active."
                        : "Onboarding pending – some mandatory stages are still incomplete."}
                    </small>
                  )}
                {onboardingData.summary?.isComplete &&
                  !onboardingMarkedComplete &&
                  !formData.password && (
                    <small className="text-muted d-block mt-1">
                      All mandatory onboarding stages are complete.
                    </small>
                  )}
              </div>

              <div>
               {roleName === "1" && onboardingMarkedComplete ? (
                  <span className="badge bg-success px-3 py-2">
                    Onboarding Complete
                  </span>
                ) : onboardingData.summary?.isComplete ? (
                  roleName === "1" ? (
                    <button
                      className="btn btn-success px-4"
                      onClick={async () => {
                        let autoPassword = formData.password;
                        if (!autoPassword) {
                          try {
                            const res = await api<{ password: string }>("/employees/generatepassword", { method: "GET" });
                            autoPassword = res.password;
                          } catch (e) {
                            toast.error("Failed to auto-generate password.");
                            return;
                          }
                        }

                        await nodeApi("/employee/onboarding/complete", {
                          method: "POST",
                          body: {
                            userId: selectedUserId,
                            ...(autoPassword ? { password: autoPassword } : {}),
                          },
                        });

                        if (selectedUserId) {
                          localStorage.setItem(
                            `onboardingComplete:${selectedUserId}`,
                            "1"
                          );
                        }

                        setOnboardingMarkedComplete(true);
                        setFormData((prev) => ({
                          ...prev,
                          is_active: true,
                          password: autoPassword || prev.password,
                        }));
                        submitAfterOnboardingRef.current = true;
                        await fetchOnboardingProgress();
                        await refreshLifecycleProgress();
                        toast.success("Onboarding marked complete");
                      }}
                    >
                      Mark Onboarding Complete
                    </button>
                  ) : (
                    <span className="badge bg-success px-3 py-2">
                      All mandatory steps completed
                    </span>
                  )
                ) : (
                  <span className="badge bg-warning text-dark px-3 py-2">
                    Onboarding Pending
                  </span>
                )}
              </div>

              {roleName === "1" &&
                onboardingData.summary?.isComplete &&
                !formData.password && (
                  <div>
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      onClick={generatePassword}
                    >
                      Generate HRMS Password
                    </button>
                  </div>
                )}
            </div>
          </div>
        )}
        {roleName == '1' &&
          exitData &&
          !["Terminated"].includes(getEffectiveStatusLabel()) &&
          !exitData.summary?.isExitComplete && (
          <div className="card mt-3 shadow-sm border-0">
            <div className="card-body d-flex justify-content-between align-items-center flex-wrap gap-2">
              <div>
                <div className="fw-semibold">Exit Status</div>
                <small className="text-muted">
                  {exitData.summary?.isExitComplete
                    ? "Exit process completed for this employee."
                    : exitData.summary?.isComplete
                    ? "All exit stages are complete – mark this employee as exited to finalize the process."
                    : "Exit process pending – complete all exit stages and mark exit complete."}
                </small>
              </div>

              <div>
  {exitData?.summary?.isExitComplete ? (
    <span className="badge bg-success px-3 py-2">
      Exit Complete
    </span>
  )  : (
    <span className="badge bg-warning text-dark px-3 py-2">
      Exit In Progress
    </span>
  )}
</div>
            </div>
          </div>
        )}
          <Tab.Container activeKey={key} onSelect={(k) => setKey(k as any)}>
            <Row className="mt-4">
              <Col>
                 <Nav variant="pills" className="flex-row">
            <Nav.Item>
              <Nav.Link eventKey="documents">Profile</Nav.Link>
            </Nav.Item>

            {roleName == '1' && (
              <>
                <Nav.Item>
                  <Nav.Link eventKey="inventory">Documents</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="ctc">Salary Structure</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="leave">Balance</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                <Nav.Link eventKey="analysis">Attendance Analysis</Nav.Link>
              </Nav.Item>
              {/* <Nav.Item>
                <Nav.Link eventKey="induction">
                  Induction Checklist
                </Nav.Link>
              </Nav.Item> */}

              </>
            )}
          </Nav>
              </Col>
            </Row>
            <Row>
              <Tab.Content>
                <Tab.Pane eventKey="documents">
                  <div className="row mt-2 pb-2 ">
                    {/* Form Section */}
                    <div className="col-lg-8 col-md-12">
                      <div className="card p-3">
                        {/* Personal, Professional & Bank Details - Insert your existing form code here */}
                        {/* Ensure all inputs are wrapped inside rows with appropriate col-md-4 col-lg-md-4 col-sm-4 col-lg-3 */}

                        {/* ...your existing form from <h5>Personal Details</h5> to Bank Details... */}
                        {/* Personal Details */}
                        <h5 className="mb-3 mt-3">Personal Details</h5>

                        <div className="row">
                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3">
                            <label>
                              Name<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={formData.name}
                              disabled={isDisabled}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  name: e.target.value,
                                });
                                if (formErrors.name) {
                                  setFormErrors((prev) => ({
                                    ...prev,
                                    name: "",
                                  }));
                                }
                              }}
                            />
                            {formErrors.name && (
                              <div style={{ color: "red" }}>
                                {formErrors.name}
                              </div>
                            )}
                          </div>

                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3">
                            <label>
                              Email<span className="text-danger">*</span>
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              value={formData.email}
                              disabled={isDisabled}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  email: e.target.value,
                                });
                                if (formErrors.email) {
                                  setFormErrors((prev) => ({
                                    ...prev,
                                    email: "",
                                  }));
                                }
                              }}
                            />
                            {formErrors.email && (
                              <div style={{ color: "red" }}>
                                {formErrors.email}
                              </div>
                            )}
                          </div>

                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3">
                            <label>
                              Date of Birth
                              <span className="text-danger">*</span>
                            </label>
                            <div className="input-icon-end position-relative">
                              <DatePicker
                                className="form-control datetimepicker ps-15"
                                value={
                                  formData.dob
                                    ? dayjs(formData.dob, "YYYY-MM-DD")
                                    : null
                                }
                                format="DD-MMM-YYYY"
                                placeholder="DD-MMM-YYYY"
                                disabled={isDisabled}
                                disabledDate={(current) =>
                                  current &&
                                  current.isSameOrAfter(dayjs(), "day")
                                }
                                onChange={(date) =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    dob: date ? date.format("YYYY-MM-DD") : "",
                                  }))
                                }
                              />

                              <span className="input-icon-addon">
                                <i className="ti ti-calendar text-gray-7" />
                              </span>
                            </div>
                            {formErrors.dob && (
                              <div style={{ color: "red" }}>
                                {formErrors.dob}
                              </div>
                            )}
                          </div>

                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3">
                            <label>
                              Contact<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              maxLength={10}
                              disabled={isDisabled}
                              className="form-control"
                              value={formData.contact}
                              onChange={(e) => {
                                const input = e.target.value.replace(/\D/g, ""); // only digits

                                setFormData({
                                  ...formData,
                                  contact: input,
                                });
                                if (formErrors.contact)
                                  setFormErrors({ ...formErrors, contact: "" });
                              }}
                            />
                            {formErrors.contact && (
                              <div style={{ color: "red" }}>
                                {formErrors.contact}
                              </div>
                            )}
                          </div>

                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3">
                            <label>
                              Gender<span className="text-danger">*</span>
                            </label>
                            <CommonSelect
                              forceFullWidth={true}
                              options={genderOptions}
                              value={genderOptions.find(
                                (opt) => opt.value === formData.gender
                              )}
                              onChange={(selectedOption: any) => {
                                setFormData({
                                  ...formData,
                                  gender: selectedOption?.value || "",
                                });
                                if (formErrors.gender)
                                  setFormErrors({ ...formErrors, gender: "" });
                              }}
                             isDisabled={isDisabled}
                            />
                            {formErrors.gender && (
                              <div style={{ color: "red" }}>
                                {formErrors.gender}
                              </div>
                            )}
                          </div>

                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3">
                            <label>PAN Number</label>
                            <input
                              type="text"
                              disabled={isDisabled}
                              className="form-control"
                              value={formData.pan}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  pan: e.target.value,
                                })
                              }
                            />
                          </div>
                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3">
                            <label>Address</label>
                            <textarea
                              className="form-control"
                              disabled={isDisabled}
                              value={formData.address}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  address: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>

                        {/* Professional Details */}
                        <h5 className="mb-3 mt-3">Professional Details</h5>
                        <div className="row">
                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3">
                            <label>
                              Employee Id<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={formData.employee_id}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  employee_id: e.target.value,
                                })
                              }
                              disabled
                            />
                          </div>
                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3">
                            <label>Internship Date</label>
                            <div className="input-icon-end position-relative">
                              <DatePicker
                                className="form-control datetimepicker ps-15"
                                value={
                                  formData.internshipDate
                                    ? dayjs(formData.internshipDate)
                                    : null
                                }
                                format="DD-MMM-YYYY"
                                placeholder="DD-MMM-YYYY"
                                disabled={isDisabled}
                                onChange={(date) =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    internshipDate: date?.toDate() || "",
                                  }))
                                }
                              />
                              <span className="input-icon-addon">
                                <i className="ti ti-calendar text-gray-7" />
                              </span>
                            </div>
                          </div>
                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3">
                            <label>
                              Employment Status
                              <span className="text-danger">*</span>
                            </label>
                            <CommonSelect
                              forceFullWidth={true}
                              options={modalStatusOptions}
                              value={modalStatusOptions.find(
                                (opt) => opt.value === formData.employmentStatus
                              )}
                              onChange={(selectedOption: any) => {
                                 const newStatus = selectedOption?.value || "";

  // store previous before changing
  prevStatusRef.current = formData.employmentStatus;
                                setFormData({
                                  ...formData,
                                  employmentStatus: selectedOption?.value || "",
                                });
                                if (formErrors.employmentStatus) {
                                  setFormErrors((prev) => ({
                                    ...prev,
                                    employmentStatus: "",
                                  }));
                                }
                              }}
                              isDisabled={isDisabled}
                            />
                            {formErrors.employmentStatus && (
                              <div style={{ color: "red", marginTop: "4px" }}>
                                {formErrors.employmentStatus}
                              </div>
                            )}
                          </div>

                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3">
                            <label>
                              Joining Date<span className="text-danger">*</span>
                            </label>
                            <div className="input-icon-end position-relative">
                              <DatePicker
                                className="form-control datetimepicker ps-15"
                                value={
                                  formData.joiningDate
                                    ? dayjs(formData.joiningDate)
                                    : null
                                }
                                format="DD-MMM-YYYY"
                                placeholder="DD-MMM-YYYY"
                                disabled={isDisabled}
                                onChange={(date) =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    joiningDate: date?.toDate() || "",
                                  }))
                                }
                              />
                              <span className="input-icon-addon">
                                <i className="ti ti-calendar text-gray-7" />
                              </span>
                            </div>
                            {formErrors.joiningDate && (
                              <div style={{ color: "red", marginTop: "4px" }}>
                                {formErrors.joiningDate}
                              </div>
                            )}
                          </div>

                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3 ">
                            <label>
                              Designation<span className="text-danger">*</span>
                            </label>
                            <CommonSelect
                              forceFullWidth={true}
                              options={modalDesignationOptions}
                              value={modalDesignationOptions.find(
                                (opt) => opt.value === formData.designation
                              )}
                              onChange={(selectedOption: any) =>
                                setFormData({
                                  ...formData,
                                  designation: selectedOption?.value || "",
                                })
                              }
                              isDisabled={isDisabled}
                            />
                          </div>

                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3">
                            <label>
                              Reporting Head
                              <span className="text-danger">*</span>
                            </label>
                            <CommonSelect
                              forceFullWidth={true}
                              options={reportingHeadOptions}
                              value={reportingHeadOptions.find(
                                (opt) => opt.value === formData.reportingHead
                              )}
                              onChange={(selectedOption: any) =>
                                setFormData({
                                  ...formData,
                                  reportingHead: selectedOption?.value || "",
                                })
                              }
                              isDisabled={isDisabled}
                            />
                          </div>

                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3">
                            <label>
                              User Role<span className="text-danger">*</span>
                            </label>
                            <CommonSelect
                              forceFullWidth={true}
                              options={userRoleOptions}
                              value={userRoleOptions.find(
                                (opt) => opt.value === formData.userRole
                              )}
                              onChange={(selectedOption: any) =>
                                setFormData({
                                  ...formData,
                                  userRole: selectedOption?.value || "",
                                })
                              }
                              isDisabled={isDisabled}
                            />
                          </div>
                           {roleName == '1' && (
                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3">
                            <label>Password</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                 disabled={isDisabled}
                                value={formData.password || ""}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    password: e.target.value,
                                  })
                                }
                              />
                              <button
                                type="button"
                                className="btn btn-primary"
                                 disabled={isDisabled}
                                onClick={generatePassword}
                              >
                                Generate
                              </button>
                            </div>
                          </div>
                           )}
                         {roleName == '1' && (
                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3 mt-2">
                            {/* Explicitly check for -1 to show the badge */}
                            {formData.is_active === -1 ? (
                              <>
                                {/* <label>Status</label> */}
                                <div className="mt-2">
                                  <span className="badge bg-warning text-dark px-3 py-2">Pre-Joining</span>
                                </div>
                              </>
                            ) : (
                              <>
                                <label>Is Active</label>
                                <div className="form-check mt-2">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="is_active"
                                    disabled={isDisabled}
                                    /* Fix: Explicitly check for true/1 to handle TS number errors */
                                    checked={formData.is_active === true || formData.is_active === 1}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                      setFormData({
                                        ...formData,
                                        is_active: e.target.checked,
                                      })
                                    }
                                  />
                                  <label className="form-check-label" htmlFor="is_active">Check</label>
                                </div>
                              </>
                            )}
                          </div>
                        )}
                           {roleName == '1' && (
                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3 mt-2">
                            <div className="form-check">
                              <label
                                className="form-check-label"
                                htmlFor="flag"
                              >
                                Do Not Show
                              </label>
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="flag"
                                 disabled={isDisabled}
                               checked={formData.flag}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    flag: e.target.checked,
                                  })
                                }
                              />
                            </div>
                          </div>
                           )}
                            {roleName == '1' && (
                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3 mt-2">
                            <label>Bypass Attendance</label>
                            <div className="form-check mt-2">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="bypassAttendance"
                                 disabled={isDisabled}
                                checked={formData.bypassAttendance}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    bypassAttendance: e.target.checked,
                                  })
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="bypassAttendance"
                              >
                                Check
                              </label>
                            </div>
                          </div>
                            )}
                             {roleName == '1' && (
                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3 mt-2">
                            <label>Permanent WFH</label>
                            <div className="form-check mt-2">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="permanentWfh"
                                 disabled={isDisabled}
                                checked={formData.permanentWfh}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    permanentWfh: e.target.checked,
                                  })
                                }
                              />
                              <label
                                className="form-wfh-label"
                                htmlFor="permanentWfh"
                              >
                                WFH
                              </label>
                            </div>
                          </div>
                             )}
                          {isExitStatus(formData.employmentStatus) && (
                            <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3">
                              <label>
                                Date of leaving
                                <span className="text-danger">*</span>
                              </label>
                              <div className="input-icon-end position-relative">
                                <DatePicker
                                  className="form-control datetimepicker ps-15"
                                  value={
                                    formData.leavingDate
                                      ? dayjs(formData.leavingDate, "YYYY-MM-DD")
                                      : null
                                  }
                                  format="DD-MMM-YYYY"
                                   disabled={isDisabled}
                                  placeholder="DD-MMM-YYYY"
                                  onChange={(date) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  leavingDate: date
                                    ? date.format("YYYY-MM-DD")
                                    : "",
                                }));
                                if (formErrors.leavingDate) {
                                  setFormErrors((prev) => ({
                                    ...prev,
                                    leavingDate: "",
                                  }));
                                }
                              }}
                                />
                                <span className="input-icon-addon">
                                  <i className="ti ti-calendar text-gray-7" />
                                </span>
                               
                              </div>
                               {formErrors.leavingDate && (
                                  <div style={{ color: "red", marginTop: "4px" }}>
                                    {formErrors.leavingDate}
                                  </div>
                                )}
                            </div>
                          )}
                        </div>

                        {/* Bank Details */}
                        <h5 className="mb-3 mt-3">Bank Details</h5>
                        <div className="row ">
                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3">
                            <label>Account Number</label>
                            <input
                              type="text"
                              // maxLength={10}
                               disabled={isDisabled}
                              className="form-control"
                              value={formData.accountNumber}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  accountNumber: e.target.value,
                                })
                              }
                            />
                          </div>
                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3">
                            <label>Account Name</label>
                            <input
                              type="text"
                              className="form-control"
                              value={formData.accountName}
                               disabled={isDisabled}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  accountName: e.target.value,
                                })
                              }
                            />
                          </div>
                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3">
                            <label>Branch Name</label>
                            <input
                              type="text"
                              className="form-control"
                               disabled={isDisabled}
                              value={formData.branchName}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  branchName: e.target.value,
                                })
                              }
                            />
                          </div>
                          <div className="col-md-4 col-lg-md-4 col-sm-4 col-lg-3">
                            <label>IFSC</label>
                            <input
                              type="text"
                              className="form-control"
                              value={formData.ifscCode}
                               disabled={isDisabled}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  ifscCode: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                        <div className="modal-footer mt-2">
                          {/* <button
                          className="btn btn-light me-2"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button> */}
                        {roleName == '1' && (
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSubmit}
                            disabled={isSaving}
                          >
                            {isSaving ? "Saving..." : "Save Changes"}
                          </button>
                        )}
                        </div>
                      </div>
                    </div>

                    {/* Sidebar Widgets Section */}
                    <div className="col-lg-4 col-md-12">
                      {/* Total Earned Widget */}
                      <div className="card mb-3">
                        <div className="card-body d-flex align-items-center">
                          <div
                            className="icon text-success"
                            style={{ fontSize: "30px" }}
                          >
                            <i className="ti ti-trophy"></i>
                          </div>
                          <div className="ms-3">
                            <h6 className="mb-0">Total Earned</h6>
                            <span>$96K +</span>
                          </div>
                        </div>
                      </div>

                      {/* Total Likes */}
                      <div className="card mb-3">
                        <div className="card-body d-flex align-items-center">
                          <div
                            className="icon text-warning"
                            style={{ fontSize: "30px" }}
                          >
                            <i className="ti ti-heart"></i>
                          </div>
                          <div className="ms-3">
                            <h6 className="mb-0">Total Likes</h6>
                            <span>6,270</span>
                          </div>
                        </div>
                      </div>

                      {/* Delivered */}
                      <div className="card mb-3">
                        <div className="card-body d-flex align-items-center">
                          <div
                            className="icon text-danger"
                            style={{ fontSize: "30px" }}
                          >
                            <i className="ti ti-briefcase"></i>
                          </div>
                          <div className="ms-3">
                            <h6 className="mb-0">Delivered</h6>
                            <span>720 Delivered</span>
                          </div>
                        </div>
                      </div>

                      {/* Jobs */}
                      <div className="card mb-3">
                        <div className="card-body d-flex align-items-center">
                          <div
                            className="icon text-primary"
                            style={{ fontSize: "30px" }}
                          >
                            <i className="ti ti-user"></i>
                          </div>
                          <div className="ms-3">
                            <h6 className="mb-0">Jobs</h6>
                            <span>614</span>
                          </div>
                        </div>
                      </div>

                      {/* Inventory */}
                      <div className="card mb-3">
                        <div className="card-header d-flex align-items-center">
                          <h6 className="card-title mb-0">Inventory</h6>
                         {roleName == '1' && (
                          <button
                            className="btn btn-outline-primary ms-auto add_btn_size"
                            title="Add Inventory"
                            onClick={handleAddInventoryClick}
                          >
                            <i className="ti ti-circle-plus"></i>
                          </button>
                         )}
                        </div>
                        <div className="card-body">
                          {inventoryData.length > 0 ? (
                            inventoryData.map((item) => (
                              <div
                                key={item.id}
                                className="d-flex align-items-center p-2 mb-2 bg-light rounded shadow-sm"
                              >
                                <img
                                  src={
                                    item.inventory_type?.image_icon ||
                                    "../assets/images/default-icon.png"
                                  }
                                  alt={item.inventory_type?.name || "Inventory"}
                                  style={{ width: "32px", height: "32px" }}
                                />
                                <div className="ms-3">
                                  <div className="fw-bold">
                                    {item.inventory_type?.name ||
                                      "Unknown Type"}
                                  </div>
                                  <div className="text-muted small">
                                    {item.inventory_brand?.name ||
                                      "Unknown Brand"}
                                    ,{item.device_code || "Unknown Code"}
                                  </div>
                                </div>
                                {roleName == '1' && (
                                <button
                                  className="btn btn-danger btn-sm ms-auto"
                                  onClick={() => handleDeleteInventory(item.id)}
                                  title="Remove Inventory"
                                >
                                  &#10005;
                                </button>
                                )}
                              </div>
                            ))
                          ) : (
                            <div className="text-center text-muted py-3">
                              No inventory assigned
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>

                {/* Inventory Tab */}
                <Tab.Pane eventKey="inventory">
                  {docError && (
                    <div className="alert alert-danger">{docError}</div>
                  )}
                  <div className="card mt-2">
                    <Table
                      columns={documentColumns}
                      dataSource={documents}
                      totalItems={docTotal}
                      pageSize={docPerPage}
                      currentPage={docPage}
                      onPageChange={(p) => setDocPage(p)}
                    />
                  </div>
                </Tab.Pane>

                {/* CTC Tab */}
                <Tab.Pane eventKey="ctc">
                  <div className="card mt-2">
                    <div className="card-body p-1">
                      <div className="d-flex justify-content-end align-items-center mb-3">
                        {ctcData.length > 0 && (
                          <i
                            className="fas fa-file-excel p-2"
                            title="Download Excel"
                            style={{
                              cursor: "pointer",
                              fontSize: "22px",
                              color: "#212529",
                            }}
                            onClick={handleDownloadCTCExcel}
                          />
                        )}
                        <button
                          type="button"
                          className="btn btn-primary d-flex align-items-center ms-2"
                          onClick={openAddCTCModal}
                        >
                          <i className="fe fe-plus me-2" /> Add Salary
                        </button>
                      </div>
                      <Table
                        columns={salaryStructure}
                        dataSource={ctcData}
                        totalItems={totalItems}
                        currentPage={currentPage}
                        onPageChange={(page) => fetchCTCData(page)}
                        pageSize={pageSize}
                      />
                    </div>
                  </div>
                </Tab.Pane>

                {/* Leave Tab */}
                <Tab.Pane eventKey="leave">
                  {leaveError && (
                    <div className="alert alert-danger">{leaveError}</div>
                  )}
                  <div className="card mt-2">
                    <Table
                      columns={leaveColumns}
                      dataSource={leaveItems}
                      totalItems={leaveTotalItems}
                      pageSize={leavePerPage}
                      currentPage={leavePage}
                      onPageChange={setLeavePage}
                    />
                  </div>
                </Tab.Pane>

                <Tab.Pane eventKey="analysis">
                  <div className="card mt-2">
                    <div className="card-body">

                      <div className="row mb-3">
                        <div className="col-md-4">
                          <label>Employee ID</label>
                          <input
                            className="form-control"
                            value={selectedUserId}
                            disabled
                          />
                        </div>

                        <div className="col-md-4">
                          <label>From Date</label>
                         <DatePicker
                          className="form-control"
                          value={analysisFromDate}
                          format="DD-MMM-YYYY"
                          placeholder="DD-MMM-YYYY"
                          allowClear
                          inputReadOnly={false}
                          onChange={(d) => {
                            setAnalysisFromDate(d);

                            // if To Date is before new From Date → clear it
                            if (analysisToDate && d && analysisToDate.isBefore(d, "day")) {
                              setAnalysisToDate(null);
                            }
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Backspace" || e.key === "Delete") {
                              setAnalysisFromDate(null);
                            }
                          }}
                          disabledDate={(current) => {
                            if (!current) return false;

                            // block previous & future years
                            // if (
                            //   current.isBefore(currentYearStart, "day")
                            // ) {
                            //   return true;
                            // }

                            // block dates after selected To Date
                            if (analysisToDate) {
                              return current.isAfter(analysisToDate, "day");
                            }

                            return false;
                          }}
                        />

                        </div>

                        <div className="col-md-4">
                          <label>To Date</label>
                          <DatePicker
                            className="form-control"
                            value={analysisToDate}
                            format="DD-MMM-YYYY"
                            placeholder="DD-MMM-YYYY"
                            allowClear
                            inputReadOnly={false}
                            onChange={(d) => setAnalysisToDate(d)}
                            onKeyDown={(e) => {
                              if (e.key === "Backspace" || e.key === "Delete") {
                                setAnalysisToDate(null);
                              }
                            }}
                            disabledDate={(current) => {
                              if (!current) return false;

                              // block previous & future years
                              // if (
                              //   current.isBefore(currentYearStart, "day")
                              // ) {
                              //   return true;
                              // }

                              // block dates before From Date
                              if (analysisFromDate) {
                                return current.isBefore(analysisFromDate, "day");
                              }

                              return false;
                            }}
                          />

                        </div>
                      </div>

                    <button
                  className="btn btn-primary"
                  disabled={!analysisFromDate || !analysisToDate || analysisLoading}
                  onClick={triggerAttendanceAnalysis}
                >
                  {analysisLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Running Analysis...
                    </>
                  ) : (
                    "Run Analysis"
                  )}
                </button>


                   {analysisLoading && analysisStatus && (
                    <div className="mt-3 p-3 border rounded bg-light">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <strong>Analysis Status</strong>
                        <span className="badge bg-warning text-dark">
                          RUNNING
                        </span>
                      </div>

                      <div className="progress" style={{ height: 8 }}>
                        <div
                          className="progress-bar progress-bar-striped progress-bar-animated"
                          style={{ width: `${analysisProgress}%` }}
                        />
                      </div>

                      <small className="text-muted d-block mt-1">
                        Processing… {analysisProgress}%
                      </small>
                    </div>
                  )}



                     {analysisResult?.summary_points && (
                      <div className="mt-4">
                        <h5 className="mb-3">Attendance Analysis Summary</h5>
                        <ul className="list-group">
                          {analysisResult.summary_points.map((p: string, i: number) => (
                            <li key={i} className="list-group-item">
                              <span
                                className="me-2 text-primary"
                                style={{ fontWeight: 600 }}
                              >
                                •
                              </span>
                              <span>{p.replace(/^[^a-zA-Z0-9]+/, "")}</span>
                              
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}


                    </div>
                  </div>
                </Tab.Pane>

                {/* <Tab.Pane eventKey="induction">
  <div className="card mt-2">
    <div className="card-body">

      <h5 className="mb-3">Employee Induction Checklist</h5>

      {inductionLoading ? (
        <div>Loading...</div>
      ) : inductionData.length === 0 ? (
        <div className="text-muted">No checklist items found</div>
      ) : (
        inductionData.map((item: InductionItem) => (
          <div
            key={item.id}
            className="d-flex justify-content-between align-items-center mb-2 border-bottom pb-2"
          >
            <div>
              <strong>{item.title}</strong>
              <div className="text-muted small">
                {item.description}
              </div>
            </div>

            <div>
              <input
                type="checkbox"
                checked={item.completed}
                disabled={roleName !== "1"}
                onChange={async (e) => {
                  await nodeApi("/employee/induction-update", {
                    method: "POST",
                    body: {
                      userId: selectedUserId,
                      checklistId: item.id,
                      value: e.target.checked,
                    },
                  });

                  fetchInductionChecklist();
                  fetchOnboardingProgress();
                  refreshLifecycleProgress();
                }}
              />
            </div>
          </div>
        ))
      )}
    </div>
  </div>
</Tab.Pane> */}

              </Tab.Content>
            </Row>
          </Tab.Container>
        </div>
        <Footer />
      </div>

      {showCTCModal && (
        <>
          {/* …Backdrop etc… */}
          <div
            className="modal-backdrop fade show"
            style={{
              backgroundColor: "rgba(0, 0, 0, 2.6)",
              zIndex: 1040,
            }}
          />
          <div
            className="modal fade show d-block"
            style={{ zIndex: 1050 }}
            tabIndex={-1}
            role="dialog"
            aria-modal="true"
          >
            <div className="modal-dialog modal-dialog-scrollable modal-lg ">
              <div className="modal-content">
                <div className="modal-header">
                  <h5>{editingCTC ? "Edit Salary" : "Add Salary"}</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                      resetSalaryFields();
                      setShowCTCModal(false);
                    }}
                  />
                </div>

                <div
                  className="modal-body"
                  style={{ maxHeight: "130vh", overflowY: "auto" }}
                >
                  <form>
                    <div className="row mb-2">
                      <div className="col-md-3">
                        <label>
                          Enter CTC (Per Annum)
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          value={ctc}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val.length <= 9) setCtc(val);
                          }}
                          onBlur={() => calculateSalary()}
                          onKeyDown={(
                            e: React.KeyboardEvent<HTMLInputElement>
                          ) =>
                            ["e", "E", "+", "-"].includes(e.key) &&
                            e.preventDefault()
                          }
                          min={0}
                          max={100000000}
                        />
                        {ctcErrors.ctc && (
                          <div className="text-danger">{ctcErrors.ctc}</div>
                        )}
                      </div>
                      <div className="col-md-3">
                        <label>
                          Enter CTC (Per Month)
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          value={monthCTC }
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val.length <= 9) setMonthCTC(val);
                          }}
                          onBlur={(e) => {
                            const val = parseFloat(e.target.value);
                            if (!isNaN(val)) {
                              const newCtc = (val * 12).toString();
                              setMonthCTC(val.toString());
                              setCtc(newCtc);
                              calculateSalary(newCtc);
                            } else {
                              setGross("");
                              setAnnextureBtotal("");
                              setTotalDeduction("");
                              setMonthCTC("");
                              setCtc("");
                              setNetSalary("");
                              setBasicSalary("");
                              sethouseRent("");
                              setTravelAllowance("");
                              setMedicalAllowance("");
                              setProfessionalTax("");
                              setSecurityDeposit("");
                              setSpecialAllowance("");
                              setCityCompensatoryAllowance("");
                              setleaveTravel("");
                              setMobileInternet("");
                              setTds("");
                              setBasic("");
                              setBasicSalaryAnnual("");
                              sethouseRentAnnual("");
                              setTravelAllowanceAnnual("");
                              setMedicalAllowanceAnnual("");
                              setProfessionalTaxAnnual("");
                              setSecurityDepositAnnual("");
                              setSpecialAllowanceAnnual("");
                              setCityCompensatoryAllowanceAnnual("");
                              setleaveTravelAnnual("");
                              setMobileInternetAnnual("");
                              setTdsAnnual("");
                              setBasicAnnual("");
                              setNetSalaryAnnual("");
                              setPayheadValues({});
                            }
                          }}
                          onKeyDown={(
                            e: React.KeyboardEvent<HTMLInputElement>
                          ) =>
                            ["e", "E", "+", "-"].includes(e.key) &&
                            e.preventDefault()
                          }
                          min={1}
                          max={100000000}
                        />
                      </div>
                      <div className="col-md-3">
                        <label>Gross Salary (Per Month)</label>
                        <input
                          type="number"
                          className="form-control"
                          value={gross}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val.length <= 9) setGross(val);
                          }}
                          // onBlur={(e) => {
                          //   const val = parseFloat(e.target.value);
                          //   if (!isNaN(val)) {
                          //     const newCtc = (val * 12).toString();
                          //     setGross(val.toString());
                          //     setCtc(newCtc);
                          //     calculateSalary(newCtc);
                          //   } else {
                          //     setGross("");
                          //     setAnnextureBtotal("");
                          //     setTotalDeduction("");
                          //     setCtc("");
                          //     setNetSalary("");
                          //     setBasicSalary("");
                          //     sethouseRent("");
                          //     setTravelAllowance("");
                          //     setMedicalAllowance("");
                          //     setProfessionalTax("");
                          //     setSecurityDeposit("");
                          //     setSpecialAllowance("");
                          //     setCityCompensatoryAllowance("");
                          //     setleaveTravel("");
                          //     setMobileInternet("");
                          //     setTds("");
                          //     setBasic("");
                          //     setBasicSalaryAnnual("");
                          //     sethouseRentAnnual("");
                          //     setTravelAllowanceAnnual("");
                          //     setMedicalAllowanceAnnual("");
                          //     setProfessionalTaxAnnual("");
                          //     setSecurityDepositAnnual("");
                          //     setSpecialAllowanceAnnual("");
                          //     setCityCompensatoryAllowanceAnnual("");
                          //     setleaveTravelAnnual("");
                          //     setMobileInternetAnnual("");
                          //     setTdsAnnual("");
                          //     setBasicAnnual("");
                          //     setNetSalaryAnnual("");
                          //     setPayheadValues({});
                          //   }
                          // }}
                          onKeyDown={(
                            e: React.KeyboardEvent<HTMLInputElement>
                          ) =>
                            ["e", "E", "+", "-"].includes(e.key) &&
                            e.preventDefault()
                          }
                          min={1}
                          max={100000000}
                        />
                      </div>

                      <div className="col-md-3">
                        <label>
                          From Date<span className="text-danger">*</span>
                        </label>
                        <div className="input-icon-end position-relative">
                          <DatePicker
                            className="form-control datetimepicker ps-15"
                            value={fromDate}
                            onChange={(date) => setFromDate(date)}
                            format="DD-MMM-YYYY"
                            placeholder="DD-MMM-YYYY"
                            allowClear
                            style={{ width: "100%" }}
                          />
                          <span className="input-icon-addon">
                            <i className="ti ti-calendar text-gray-7" />
                          </span>
                        </div>
                        {ctcErrors.fromDate && (
                          <div className="text-danger">
                            {ctcErrors.fromDate}
                          </div>
                        )}
                      </div>
                    </div>
                   <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead className="thead-light">
                          <tr className="custom-row">
                            <th className="text-center">Payheader</th>
                            <th className="text-center">Per Month</th>
                            <th className="text-center">Per Annum</th>
                          </tr>
                        </thead>
                        <tbody>
                           <tr>
                           <td colSpan={3}> 
                            <strong>Annexure A</strong>
                           </td>
                          </tr>
                          {payheadData
                            .filter((ph) => ph.category === "A")
                            .map((ph) => {
                              const editableMonthlyCodes = ["Basic", "TA", "MA", "SD", "TDS", "CCA", "LTA", "MIA", "ESIC","PF(B)","OtherDeduction"];
                              const isEditable = editableMonthlyCodes.includes(ph.code);
                              const monthlyValue = payheadValues[ph.code] ?? "";

                            return (
                              <tr key={ph.code} className="custom-row">
                                <td>{ph.name}</td>
                                {/* Per Month */}
                                <td>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={monthlyValue}
                                    onChange={(e) => {
                                      const text = e.target.value;
                                      if (text === "") {
                                        setPayheadValues((prev) => {
                                          const copy = { ...prev };
                                          delete copy[ph.code];
                                          return copy;
                                        });
                                      } else {
                                        const parsed = parseFloat(text);
                                        setPayheadValues((prev) => ({
                                          ...prev,
                                          [ph.code]: isNaN(parsed) ? 0 : parsed,
                                        }));
                                      }
                                    }}
                                    onBlur={() => {
                                      if (["Basic","TA", "MA","SD", "TDS", "PF(B)","PF(C)", "ESIC","OtherDeduction"].includes(ph.code)) {
                                        recalculateSalary();
                                      }
                                      if (["CCA", "LTA", "MIA"].includes(ph.code)) {
                                        recalculateSA();
                                      }
                                    }}
                                    disabled={!isEditable}
                                    onKeyDown={(e) =>
                                      ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                                    }
                                    min={0}
                                    max={100000000}
                                  />
                                </td>

                                {/* Per Annum */}
                                <td>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={monthlyValue  ? monthlyValue * 12 : ""}
                                    disabled
                                  />
                                </td>
                              </tr>
                            );
                          })}
                           {/* Gross Row Added After .map() */}
                            <tr className="custom-row">
                              <td><strong>Gross(A)</strong></td>
                              <td>
                                <input
                                  type="number"
                                  value={gross}
                                  className="form-control form-control-sm"
                                  disabled
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  value={gross ? Number(gross) * 12 : ""}
                                  className="form-control form-control-sm"
                                  disabled
                                />
                              </td>
                            </tr>
                           <tr>
                            <td colSpan={3}> 
                              <strong>Annexure B</strong>
                            </td>
                           </tr>
                            {payheadData
                            .filter((ph) => ph.description?.toLowerCase() == "employer")
                            .map((ph) => {
                              const editableMonthlyCodes = ["SD", "TDS", "CCA", "LTA", "MIA", "ESIC","PF(B)","OtherDeduction"];
                              const isEditable = editableMonthlyCodes.includes(ph.code);
                              const monthlyValue = payheadValues[ph.code] ?? "";

                            return (
                              <tr key={ph.code} className="custom-row">
                                <td>{ph.name}</td>

                                {/* Per Month */}
                                <td>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={monthlyValue}
                                    onChange={(e) => {
                                        const text = e.target.value;
                                        const parsed = parseFloat(text);

                                        setPayheadValues((prev) => ({
                                          ...prev,
                                          [ph.code]: text === "" || isNaN(parsed) ? 0 : parsed,
                                        }));
                                      }}

                                    onBlur={() => {
                                      if (["SD", "TDS", "PF(B)","PF(C)", "ESIC","OtherDeduction"].includes(ph.code)) {
                                        recalculateSalary();
                                      }
                                      if (["CCA", "LTA", "MIA"].includes(ph.code)) {
                                        recalculateSA();
                                      }
                                    }}
                                    disabled={!isEditable}
                                    onKeyDown={(e) =>
                                      ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                                    }
                                    min={0}
                                    max={100000000}
                                  />
                                </td>

                                {/* Per Annum */}
                                <td>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={monthlyValue  ? monthlyValue * 12 : ""}
                                    disabled
                                  />
                                </td>
                              </tr>
                            );
                          })}
                           {/* Gross Row Added After .map() */}
                            <tr className="custom-row">
                              <td><strong>Total(B)</strong></td>
                              <td>
                                <input
                                  type="number"
                                  className="form-control form-control-sm"
                                  value = {AnnextureBTotal}
                                  disabled
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  className="form-control form-control-sm"
                                    value={AnnextureBTotal === "" || AnnextureBTotal === null || AnnextureBTotal === undefined
                                    ? ""
                                    : Number(AnnextureBTotal) * 12
                                }                        
                                  disabled
                                />
                              </td>
                            </tr>
                           <tr></tr>
                           <tr>
                              <td colSpan={3}> 
                                <strong>Annexure C</strong>
                              </td>
                           </tr>
                            {payheadData
                            .filter((ph) => {
                             if (ph.code.startsWith("PF")) {
                                return ph.category === "D" && ph.description?.toLowerCase() === "employee";
                              }
                              return ph.category === "D";
                            })  
                            .sort((a, b) => {
                                const aStartsWithPF = a.code.startsWith("PF");
                                const bStartsWithPF = b.code.startsWith("PF");

                                if (aStartsWithPF && !bStartsWithPF) return -1; 
                                if (!aStartsWithPF && bStartsWithPF) return 1;  
                                return 0; 
                              })          
                            .map((ph) => {
                              const editableMonthlyCodes = ["SD", "TDS", "CCA", "LTA", "MIA", "ESIC","PF(B)","PF(C)","OtherDeduction"];
                              const isEditable = editableMonthlyCodes.includes(ph.code);
                              const monthlyValue = payheadValues[ph.code] ?? "";

                            return (
                              <tr key={ph.code} className="custom-row">
                                <td>{ph.name}</td>

                                {/* Per Month */}
                                <td>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={monthlyValue}
                                    onChange={(e) => {
                                        const text = e.target.value;
                                        const parsed = parseFloat(text);

                                        setPayheadValues((prev) => ({
                                          ...prev,
                                          [ph.code]: text === "" || isNaN(parsed) ? 0 : parsed,
                                        }));
                                      }}
                                    onBlur={() => {
                                      if (["SD", "TDS", "PF(B)","PF(C)", "ESIC","OtherDeduction"].includes(ph.code)) {
                                        recalculateSalary();
                                      }
                                      if (["CCA", "LTA", "MIA"].includes(ph.code)) {
                                        recalculateSA();
                                      }
                                    }}
                                    disabled={!isEditable}
                                    onKeyDown={(e) =>
                                      ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                                    }
                                    min={0}
                                    max={100000000}
                                  />
                                </td>

                                {/* Per Annum */}
                                <td>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={monthlyValue ? monthlyValue * 12 : ""}
                                    disabled
                                  />
                                </td>
                              </tr>
                            );
                          })}
                         {/* Gross Row Added After .map() */}
                            <tr className="custom-row">
                              <td><strong>Total(C)</strong></td>
                              <td>
                                <input
                                  type="number"
                                  className="form-control form-control-sm"
                                  value = {totalDeduction}
                                  disabled
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  className="form-control form-control-sm"
                                  value={totalDeduction === "" || totalDeduction === null || totalDeduction === undefined
                                    ? ""
                                    : Number(totalDeduction) * 12
                                }
                                  disabled
                                />
                              </td>
                            </tr>
                           <tr>

                           </tr>
                          {/* Net and Annual Salary Rows */}
                          <tr>
                            <td><strong>Net Salary(A-C)</strong></td>
                            <td>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                value={netSalary}
                                disabled
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                value={Number(netSalary) * 12}
                                disabled
                              />
                            </td>
                          </tr>
                           <tr>
                            <td><strong>CTC(A+B)</strong></td>
                            <td>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                value={monthCTC}
                                disabled
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                value={
                                  monthCTC === "" || monthCTC === null || monthCTC === undefined
                                    ? ""
                                    : Number(monthCTC) * 12
                                }
                                disabled
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* Actions */}
                    <div className="mt-3">
                      {(!editingCTC || islatest) && (
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleSubmitStructure}
                        >
                          Save
                        </button>
                      )}
                      &nbsp;
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          resetSalaryFields();
                          setShowCTCModal(false);
                        }}
                      >
                        Close
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {isModalOpen && (
        <div
          className="modal"
          style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Inventory</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setIsModalOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmitInventory}>
                  <div className="form-group">
                    <label htmlFor="inventoryType" className="mb-2">
                      Select Inventory
                    </label>
                    <CommonSelect
                      isMulti={true}
                      forceFullWidth={true}
                      // isHeight={true}
                      options={inventoryOptions}
                      value={selectedOptions}
                      onChange={handleInventoryTypeChange}
                    />
                  </div>
                  <button type="submit" className="btn btn-primary mt-3">
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Upload/Edit Modal */}
      {showModal && (
        <>
          {/* Backdrop */}
          <div
            className="modal-backdrop fade show"
            style={{
              backgroundColor: "rgba(0, 0, 0, 2.6)",
              zIndex: 1040,
            }}
          />
          <div
            className="modal fade show d-block"
            style={{ zIndex: 1050 }}
            tabIndex={-1}
            role="dialog"
            aria-modal="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <form onSubmit={handleSubmitModal}>
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {isEditing ? "Edit" : "Upload"} Document
                    </h5>
                    <button
                      type="button"
                      className="btn btn-close"
                      onClick={handleCloseModal}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="form-group">
                      <label>Number</label>
                      <input
                        type="text"
                        name="document_number"
                        className="form-control"
                        value={documentForm.document_number || ""}
                        onChange={handleFormChange}
                      />
                    </div>
                    <div className="form-group mb-3 mt-3">
                      <label
                        className="mb-1"
                        htmlFor="documentSubmittedYes"
                      >
                        Have you submitted this document?
                      </label>

                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="documentSubmitted"
                          id="documentSubmittedYes"
                          checked={documentSubmitted === true}
                          onChange={() => setDocumentSubmitted(true)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="documentSubmittedYes"
                        >
                          Yes, I have submitted
                        </label>
                      </div>

                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="documentSubmitted"
                          id="documentSubmittedNo"
                          checked={documentSubmitted === false}
                          onChange={() => setDocumentSubmitted(false)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="documentSubmittedNo"
                        >
                          Will submit later
                        </label>
                      </div>
                    </div>

                    {documentSubmitted !== false ? (
                      <div className="form-group">
                        <label>
                          File<span className="text-danger">*</span>
                        </label>
                        <input
                          type="file"
                          name="document_path"
                          className="form-control"
                          accept=".pdf,image/*"
                          onChange={handleFormChange}
                        />
                        {formErrors.document_path && (
                          <div className="text-danger">
                            {formErrors.document_path}
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="alert alert-info py-2">
                        You selected <strong>Will submit later</strong> –
                        file upload is not required now.
                      </div>
                    )}
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-light me-2"
                      onClick={handleCloseModal}
                    >
                      Close
                    </button>
                    <button type="submit" className="btn btn-primary">
                      {isEditing ? "Save" : "Upload"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}

      {showDeleteModal1 && (
        <>
          {/* Backdrop */}
          <div
            className="modal-backdrop fade show"
            style={{
              backgroundColor: "rgba(0, 0, 0, 2.6)",
              zIndex: 1040,
            }}
          />
          <div
            className="modal fade show d-block"
            style={{ zIndex: 1050 }}
            role="dialog"
            tabIndex={-1}
            aria-modal="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title">Delete Structure</h4>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeDeleteModal1}
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  <p>Are you sure you want to delete this record?</p>
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-cancel"
                    onClick={closeDeleteModal1}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={handleConfirmedDeleteStructure}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <>
          {/* Backdrop */}
          <div
            className="modal-backdrop fade show"
            style={{
              backgroundColor: "rgba(0, 0, 0, 2.6)",
              zIndex: 1040,
            }}
          />
          <div
            className="modal fade show d-block"
            style={{ zIndex: 1050 }}
            tabIndex={-1}
            role="dialog"
            aria-modal="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title">Delete Document</h4>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeDeleteModal}
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  <p>Are you sure you want to delete this record?</p>
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-cancel"
                    onClick={closeDeleteModal}
                    // data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={handleDeleteDocument}
                    data-bs-dismiss="modal"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default Profile;
